/* eslint-disable @typescript-eslint/member-ordering */
import { Component, ElementRef, EventEmitter, Inject, Input, OnInit, OnDestroy, Optional, Output, ViewChild } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatAutocomplete, MatAutocompleteTrigger } from '@angular/material/autocomplete';
import * as dayjs from 'dayjs';
import { DaterangepickerDirective } from 'ngx-daterangepicker-material';
import { AddressesService } from 'app/home/search-box/service/addresses.service';
import { BsModalService, BsModalRef, ModalOptions } from 'ngx-bootstrap/modal';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { UserService } from 'app/pages/com.usblick.common/auth/user.service';
import { MaterialModalConfirmComponent } from '../material-modal-confirm/material-modal-confirm.component';
import { DateRangePickerService } from '../date-range-picker/date-range-picker.service';
import { FormOfflineService } from './form-offline.service';
import { UsbRequestHeaderComponent } from './request-header/request-header.component';
import { UsbExperienceFormComponent } from './experience-form/experience-form.component';
import { UsbTransferFormComponent } from './transfer-form/transfer-form.component';
import { buildTransferPreferences, unionPreference } from './transfer-preferences';
import { RestService } from '../rest.service';
import { HttpErrorResponse } from '@angular/common/http';
import { BedType, BoardType, CategoryType, MAX_OFFLINE_ROOMS, RommType, TimeDay, TransmissionType, TypeTransfer, VehicleTypes, VehicleTypesCar } from './models';
import { NgxSpinnerService } from 'ngx-spinner';
import * as moment from 'moment';
import { NotificationService } from '../notifications/notification.service';
import { Subject, of } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap, takeUntil, tap } from 'rxjs/operators';
import { ClientListModalComponent } from '../modals/client-list-modal/client-list-modal.component';
import { ConfirmationModalComponent } from '../modals/confirmation-modal/confirmation-modal.component';
import { getLabelForPath, getMessageForPath, markFormInvalid, scrollToFirstInvalid } from './form-offline.required-fields';
import { formatAmountEnUs, parseAmountEnUs } from './form-offline.amount-format';
import {
  countRoomPreferences,
  hasRoomPreferences,
  roomPreferencesStatusLabel,
  ROOM_PREFERENCES_TOTAL
} from './form-offline.preferences-status';
type OfflineFilePax = {
  idUnique: number;
  first_name: string;
  last_name: string;
  type: 'adult' | 'children';
  age?: number | null;
  document_number?: string;
  relation_ship?: string;
};

@Component({
  selector: 'usb-form-offline',
  templateUrl: './form-offline.component.html',
  styleUrls: ['./form-offline.component.scss'],
  providers: [AddressesService]
})
 export class FormOfflineComponent implements OnInit, OnDestroy {
  @Input() clientSetting: any;
  /**
   * Metadata del file a preseleccionar. Se usa cuando el componente se
   * renderiza FUERA de un MatDialog (página `/offline-quote`): en el modal el
   * dato viaja por `MAT_DIALOG_DATA`.
   */
  @Input() prefillFile: any;
  /**
   * Emite cuando el usuario cierra el formulario. En el modal no se escucha
   * (el cierre lo maneja el MatDialog), pero en la página sirve para volver
   * al listado anterior.
   */
  @Output() closed = new EventEmitter<void>();
  /**
   * Emite cuando la solicitud se envió con EXITO.
   *
   * En el modal no se escucha (el cierre lo maneja el MatDialog), pero en la
   * página `/offline-quote` sirve para resetear el formulario SIN navegar:
   * el `closed` queda reservado para el cierre explícito del usuario (botón
   * "Cerrar" / X).
   */
  @Output() submitted = new EventEmitter<void>();
  @ViewChild(DaterangepickerDirective) picker!: DaterangepickerDirective;
  @ViewChild("destination") myInputField: ElementRef;
  @ViewChild('autocompleteInput') autocompleteInput!: ElementRef;
  /**
   * Anchor del hero (tabs del formulario). El botón "Solicitar cotización"
   * hace scroll hasta acá para llevar el formulario a la vista.
   */
  @ViewChild('quotationFormAnchor') quotationFormAnchor?: ElementRef<HTMLElement>;
  tab: string = "hotel";
  formHotel: FormGroup;
  formTransfer: FormGroup;
  formRentACar: FormGroup;
  formExperience: FormGroup;
  startDate: any;
  endDate: any;
  dateRange: any = { start: null, end: null };
  minDate: any;
  maxDate: Date;
  /** Límite superior del daterangepicker (offline no cotiza tan lejos como online). */
  maxDateOffline: any;
  /** Servicio custom que agrega el tooltip "X días / X noches" al popup del daterangepicker. */
  calendarSyncOffline: DateRangePickerService;
  max: number;
  rate:number = 0;

  boardType = BoardType;
  roomType = RommType;
  transmissionType = TransmissionType;
  categoryType = CategoryType;
  bedType = BedType;
  typeTransfer = TypeTransfer;
  vehicleTypes = VehicleTypes;
  timeDay = TimeDay;
  vehicleTypesCar = VehicleTypesCar;

  availablePax: OfflineFilePax[] = [];
  loadingPax = false;

  /**
   * Vuelos del file seleccionado (para el bloque "Vuelos asociados" del tab
   * de traslados).
   */
  fileFlights: any[] = [];
  loadingFlights = false;

  roomsAndPassengers: string = 'Rooms and passengers';
  isCollapsed: boolean = false;
  /**
   * Indice de la habitacion whose preferences are shown in the "Preferencias"
   * tabs (Block 3). One tab per room of the `room` FormArray.
   */
  activeRoomTab: number = 0;
  isHoverRoom: boolean = false;
  isHoverConfirm: boolean = false;
  bgClientColor: string = '#00d096';
  originInputValue: string = '';
  pickup: any;
  dropoff: any;
  selectediataCodeDestiny: any;
  selectediataCodeOrigin: any;
  destinationInputValue: any;
  /**
   * IATA de la ciudad seleccionada en el autocomplete de "Destino".
   * Cuando tiene valor, el selector de hoteles usa el endpoint
   * /utilities/hotels-by-city-iata/{iata} en lugar de /searchlocations,
   * para devolver SOLO los hoteles de esa ciudad.
   * Sin IATA, vuelve al fallback de /searchlocations (comportamiento previo).
   */
  selectedDestinationIata: string | null = null;
  isHoveredCancelDate: boolean;
  isHovered = false;
  mesaggeErrorVisibleOrigin: boolean = false;
  mesaggeErrorVisibleDestination: boolean = false;
  dpConfig: Partial<BsDatepickerConfig> = new BsDatepickerConfig();
  now = new Date();
  currentTime = this.now.toLocaleTimeString([], {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    });
  oneWay: boolean = true;
  backgroundSelect: any;
  buttonColorActive: any;
  buttonTextActive: any;
  formHotelEdited = false;
  formTransferEdited = false;
  formRentACarEdited = false;
  formExperienceEdited = false;
  edit: boolean = false;

  get requestReady(): boolean {
    if (!this.selectedFileId || !this.selectedClientId) {
      return false;
    }
    if (this.tab === 'hotel') {
      const paxId = this.formHotel?.get('passenger.id')?.value;
      const paxFn = this.formHotel?.get('passenger.first_name')?.value;
      const paxLn = this.formHotel?.get('passenger.last_name')?.value;
      return Boolean(paxId || (paxFn && paxLn));
    }
    if (this.tab === 'transfer') {
      const paxId = this.formTransfer?.get('passenger.id')?.value;
      const paxFn = this.formTransfer?.get('passenger.first_name')?.value;
      const paxLn = this.formTransfer?.get('passenger.last_name')?.value;
      const requestType = this.formTransfer?.get('requestType')?.value;
      if (requestType && requestType !== 'quotation') {
        if (!paxId && !(paxFn && paxLn)) {
          return false;
        }
      }
      return true;
    }
    if (this.tab === 'experience') {
      const paxId = this.formExperience?.get('passenger.id')?.value;
      const paxFn = this.formExperience?.get('passenger.first_name')?.value;
      const paxLn = this.formExperience?.get('passenger.last_name')?.value;
      const requestType = this.formExperience?.get('requestType')?.value;
      if (requestType && requestType !== 'quotation') {
        if (!paxId && !(paxFn && paxLn)) {
          return false;
        }
      }
      return true;
    }
    return false;
  }
  /** When true, the form fields remain editable (not disabled) so user can modify and resubmit. */
  reopen: boolean = false;
  bsConfig: object;
  public editData: any;
  bsModalRef?: BsModalRef;
  /**
   * Cliente seleccionado desde el ClientListModalComponent.
   * Se persiste en el formHotel (sub-FormGroup `client`) y se manda
   * al backend como client_id en el payload top-level.
   */
  selectedClient: any = null;
  /** Tipo de solicitud: 'quotation' (cotización) o 'reservation' (reserva). */
  requestType: 'quotation' | 'reservation' = null;
  /**
   * Código de moneda que se muestra en los labels de los inputs de precio
   * (líneas 856 y 1284 del template). Se resuelve en ngOnInit con la cadena
   * de fallback: data.currencyAgency.code → userService.currency.code → 'ARS'.
   */
  currencyCode: string = 'ARS';
  /**
   * Lista de países para el autocomplete de phone_code del sub-form de cliente.
   * Misma fuente que usa itinerary-owner: `/utilities/countries`.
   */
  countriesData: any[] = [];
  /**
   * País actualmente seleccionado para phone_code (objeto completo).
   * Sirve para resolver el phone_code_number y mostrar el label legible.
   */
  phoneCodeSelected: any = null;
  /**
   * Lista filtrada de países para el autocomplete de nacionalidad.
   * Se alimenta de `countriesData` (misma fuente que phone_code) y se recorta
   * a medida que el usuario tipea.
   */
  filteredNationalities: any[] = [];
  /**
   * Nombre del país seleccionado como nacionalidad. Cuando tiene valor, el
   * input pasa a modo readonly con la X para borrar (mismo patrón que el
   * search-box de hotels).
   *
   * A diferencia de hotels, acá guardamos el NOMBRE del país (no el
   * country_code) porque `nationality` viaja tal cual al payload offline y el
   * modo edit hace patchValue con texto libre del backend (ver initEditForm).
   */
  selectNationalityName = '';
  /**
   * True cuando el valor de `nationality` proviene de una opción de la lista
   * de países (o del backend al rehidratar el form). Si el agente escribe a
   * mano, el flag queda en false y el campo es inválido.
   */
  nationalitySelected = false;
  /** Opciones de título para el select del sub-form de cliente. */
  clientTitleOptions = ['Sr.', 'Sra.', 'Dr.', 'Lic.'];
  /**
   * Opciones de Política de cancelación (Block 3).
   * value=null representa "Indistinta" (sin selección).
   */
  cancellationPolicyOptions: { value: any; label: string }[] = [
    { value: 'C', label: 'Cancelación gratuita' },
    { value: 'R', label: 'Reembolsable' },
    { value: 'NR', label: 'No reembolsable' }
  ];
  /**
   * Estado de la sección colapsable "Expandir tu búsqueda".
   * `hotelSuggestSectionOpen = false`: colapsada, se muestra el botón para abrir.
   * `hotelSuggestSectionOpen = true`: expandida, se ve input + botón Buscar + resultados.
   */
  hotelSuggestSectionOpen = false;
  showHotelSuggest = false;
  hotelSuggestLoading = false;
  hotelSuggestResults: any[] = [];
  hotelSuggestError: string | null = null;
  /**
   * Texto del input de búsqueda dentro de la sección "Expandir tu búsqueda".
   * Es state UI (no parte del FormGroup) porque es efímero: solo sirve
   * para disparar la búsqueda cuando el usuario hace click en "Buscar".
   */
  hotelSuggestSearchInput: string = '';
  /**
   * Estado del bloque "Expandir tu búsqueda" (pill colapsable con 2 inputs).
   * Se mantiene separado del flujo legacy de hotelSuggest (que ya no se renderiza).
   */
  expandSearchSection = false;
  addressSearch = '';
  searchNotesSearch = '';

  /**
   * User-facing label for a required field within a form.
   * Used by the inline error spans in the template.
   */
  requiredFieldLabel(formName: string, path: string): string {
    return getLabelForPath(formName, path);
  }

  /**
   * Specific contextual error message for a required field
   * (e.g. "Ingresá el nombre del hotel" instead of "Obligatorio").
   * Used by the inline `<span class="field-error">` in the template.
   */
  requiredFieldMessage(formName: string, path: string): string {
    return getMessageForPath(formName, path);
  }

  /**
   * True if the `room` FormArray has any control that is invalid
   * because of a required-validator (qtyAdults < 1 or a child age
   * left empty). Used by the inline message next to the
   * "Habitaciones y pasajeros" button.
   */
  hasRoomError(): boolean {
    const roomArray = this.formHotel?.get('room') as FormArray | undefined;
    if (!roomArray) return false;
    for (const roomGroup of roomArray.controls) {
      const qtyAdults = roomGroup.get('qtyAdults');
      if (qtyAdults?.hasError('required') || qtyAdults?.hasError('min')) {
        return true;
      }
      const childsage = roomGroup.get('childsage') as FormArray | null;
      if (childsage) {
        for (const ageGroup of childsage.controls) {
          const age = ageGroup.get('age');
          if (age?.hasError('required') || (age?.value !== null && (age?.hasError('min') || age?.hasError('max')))) {
            return true;
          }
        }
      }
    }
    return false;
  }

  /**
   * Returns a contextual message for the most relevant room error.
   * Priority: missing age > invalid adult count.
   */
  roomsErrorMessage(): string {
    const roomArray = this.formHotel?.get('room') as FormArray | undefined;
    if (!roomArray) return 'Revisá la cantidad de pasajeros';
    let firstRoomWithBadAge = -1;
    for (let i = 0; i < roomArray.controls.length; i++) {
      const roomGroup = roomArray.controls[i];
      const qtyAdults = roomGroup.get('qtyAdults');
      if (qtyAdults?.hasError('required') || qtyAdults?.hasError('min')) {
        return `Indicá al menos 1 adulto en la habitación ${i + 1}.`;
      }
      const childsage = roomGroup.get('childsage') as FormArray | null;
      if (childsage && firstRoomWithBadAge === -1) {
        for (const ageGroup of childsage.controls) {
          const age = ageGroup.get('age');
          if (age?.hasError('required')) {
            firstRoomWithBadAge = i;
            break;
          }
        }
      }
    }
    if (firstRoomWithBadAge >= 0) {
      return `Indicá la edad de los niños en la habitación ${firstRoomWithBadAge + 1}.`;
    }
    return 'Revisá la cantidad de pasajeros';
  }

  toggleExpandSearch(): void {
    this.expandSearchSection = !this.expandSearchSection;
  }
  /**
   * Mientras el selector extendido está abierto, forzamos el cierre del
   * mat-autocomplete de hotelsName (no queremos los dos dropdowns a la vez).
   */
  closeHotelsNameAutocomplete = false;
  /**
   * Estado del segundo paso: cuando el usuario selecciona una sugerencia,
   * polleamos el `run_id` para traer los datos completos. Mientras tanto
   * mostramos un loader y deshabilitamos el resto del selector.
   */
  hotelSuggestEnriching = false;
  /**
   * Mensaje final cuando el run termina pero el hotel aún no aparece
   * en searchlocations (enriquecimiento async tardó más de la cuenta).
   */
hotelSuggestPending = false;
  private originalPickerPosition = { top: 0, left: 0 };

  // --- State para el selector de files existentes ---
  existingFiles: any[] = [];
  loadingFiles = false;
  loadingCountries = false;
  selectedFileId: number | null = null;
  /** Texto que se muestra en el input de búsqueda de files. */
  fileSearchText = '';
  /**
   * Modelo para el mat-autocomplete. Cuando el usuario selecciona un file,
   * acá queda el objeto completo (no solo el id) para que `displayWith`
   * muestre el label legible.
   */
  fileAutocompleteModel: any = null;
  /** File actualmente seleccionado (objeto completo, no solo el id). */
  selectedFile: any = null;
  /**
   * Id del file del itinerary activo que hay que preseleccionar cuando se
   * abre el modal desde el header (prefill). Queda pendiente hasta que la
   * lista de files termina de cargar: recién ahí se puede resolver el label
   * real y los clientes del file.
   */
  private pendingPrefillFileId: number | null = null;
  /** Token de debounce para evitar una request por cada tecla tipeada. */
  private fileSearchDebounce: any = null;
  /**
   * ID del cliente seleccionado del file elegido. State UI (no parte del
   * FormGroup) porque es efímero — al elegir un cliente autocompleta el
   * sub-form `client` y bloquea los inputs de nombre/apellido.
   */
  selectedClientId: number | string | null = null;
  /**
   * `true` cuando el usuario clickeó "+ Crear nuevo nombre de file" para
   * tipear un nombre custom. Cuando es true, se oculta el select de files
   * y se muestra el input `fileName`.
   */
  showNewFileNameInput = false;
  /**
   * `true` cuando el usuario clickeó "+ Crear nuevo cliente" para tipear
   * los datos del cliente manualmente. Cuando es true, se oculta el select
   * de cliente y se muestra el sub-form `client` con los inputs editables.
   */
  showNewClientInput = false;
  /**
   * Estado del sub-form "Crear nuevo File" (Bloque 1, debajo del select de File).
   * Los campos se manejan con ngModel local (no entran al FormGroup principal)
   * para no tocar el payload que ya se envía al backend.
   * `onCreateNewFile()` debe ser implementado para hacer el POST y refrescar `existingFiles`.
   */
  newFilePassenger: string = '';
  newFilePhone: string = '';
  /**
   * phone_code numérico que se envía al backend. Se setea a partir del
   * autocomplete (string plano, ej. "54") o del input tipeado.
   */
  newFilePhoneCode: string = '';
  /**
   * Modelo del input del phone_code. Mientras el usuario tipea, contiene
   * el string crudo. Cuando selecciona del autocomplete, contiene el objeto
   * `country` (lo que `displayCountryFn` necesita para mostrar el label).
   */
  newFilePhoneCodeModel: any = '';
  newFileEmail: string = '';
  newFilePassengerError: boolean = false;
  newFilePhoneError: boolean = false;
  newFilePhoneCodeError: boolean = false;
  newFileEmailError: boolean = false;

  /**
   * Valida los 3 campos locales del sub-form "Crear nuevo File".
   */
  isNuevoFileValid(): boolean {
    const emailOk = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((this.newFileEmail || '').trim());
    return Boolean(
      (this.formHotel.get('fileName')?.value || '').toString().trim() &&
      (this.newFilePassenger || '').trim() &&
      (this.newFilePhone || '').trim() &&
      (this.newFilePhoneCode || '').trim() &&
      emailOk
    );
  }

  /**
   * Handler del autocomplete de phone_code del sub-form "Crear nuevo File".
   * Cuando el usuario selecciona un país, guardamos el phone_code numérico
   * (lo que el backend espera) y dejamos el modelo del input apuntando al
   * objeto `country` para que `displayCountryFn` muestre el label legible.
   */
  onNewFileCountrySelected(country: any): void {
    if (!country) {
      return;
    }
    this.newFilePhoneCode = String(country.phone_code || '');
    this.newFilePhoneCodeModel = country;
  }

  /**
   * Handler del input del phone_code cuando el usuario tipea o borra.
   * Si el modelo es un string (no un objeto seleccionado), sincronizamos
   * el phone_code. Si está vacío, limpiamos `newFilePhoneCode`.
   */
  onNewFilePhoneCodeInput(value: any): void {
    if (!value) {
      this.newFilePhoneCode = '';
      this.newFilePhoneCodeModel = '';
      return;
    }
    if (typeof value === 'string') {
      this.newFilePhoneCode = value.trim();
    }
    // Si es objeto (selección del autocomplete), no tocamos newFilePhoneCode
    // porque ya lo setea `onNewFileCountrySelected`.
  }

  /**
   * Crea un cliente nuevo (pasajero) y un file/itinerary nuevo asociado al
   * agente y agencia del usuario logueado, igualando el flujo de
   * `itinerary-owner.saveFirstItinerary()`. Al terminar, refresca el listado
   * de files existentes, preselecciona el file recién creado y preselecciona
   * también al cliente nuevo en el selector de clientes del form.
   *
   * Encadena 3 requests:
   *   1) POST /clients       -> crea el cliente y devuelve `response.id`
   *   2) POST /itineraries   -> crea el file vinculado al cliente
   *   3) POST /clients/agency -> asocia el cliente a la agencia
   */
  onCreateNewFile(): void {
    // Método removido: la creación de file/cliente desde el modal offline
    // ya no se ofrece en UI. El cliente se resuelve desde el pasajero
    // seleccionado vía `onPassengerIdChange`.
    // Se conserva la firma vacía solo para evitar referencias rotas desde
    // templates legacy. Se debería eliminar junto con sus inputs/outputs.
  }

  /**
   * Opciones del autocomplete de "Nombre de hoteles".
   * Solo hoteles — filtramos las ciudades en el front.
   */
  hotelsNameOptions: any[] = [];

  /**
   * Cache en memoria de los hoteles de la ciudad seleccionada en "Destino".
   * Se llena cuando el usuario elige una ciudad (vía /hotels-by-city-iata/{iata})
   * y se filtra localmente en `setupHotelsNameAutocomplete` cuando el usuario
   * tipea en el input de hotel. Sin IATA, queda vacío y se cae al fallback
   * de /searchlocations.
   */
  hotelsByCityCache: any[] = [];

  /**
   * Flag UI: true mientras se está cargando `hotelsByCityCache` después de
   * que el usuario selecciona una ciudad en "Destino". Sirve para mostrar
   * un loader al lado del input "Nombre del hotel".
   */
  loadingHotelsByCity = false;

  /**
   * `true` cuando hay un valor de referencia válido (`> 0`) para el hotel
   * seleccionado, cargado vía `/zoco/hotels/{id}/referential-costs`.
   * `false` cuando el endpoint no trajo datos, devolvió `referential_cost`
   * faltante/0/inválido, o todavía no se buscó un hotel.
   *
   * El HTML lo usa para mostrar el placeholder y el icono de "sin dato" en el
   * input readonly "Valor estimado por noche" (Bloque 2 derecha).
   */
  hasReferentialCost = false;

  /**
   * `true` mientras hay un request en vuelo a `/referential-costs`. El HTML
   * lo usa para mostrar un spinner en lugar del icono de "sin dato" durante
   * la consulta, en el input "Valor estimado por noche".
   */
  loadingReferentialCost = false;

  /**
   * Token anti-race: cuando el usuario cambia de hotel rápido, las respuestas
   * viejas pueden llegar después que la nueva. Guardamos el id del último
   * pedido en `subscribe` y descartamos respuestas cuyo `hotelId` no coincida.
   */
  private latestReferentialHotelId: number | string | null = null;

  /**
   * Opciones del autocomplete de "Destino".
   * Solo ciudades/ubicaciones — filtramos hoteles/airports en el front.
   */
  destinationOptions: any[] = [];

  /**
   * Subject para disparar la busqueda con debounce (300ms) y cancelar requests en vuelo.
   */
  private hotelsNameSearch$ = new Subject<string>();
  private destinationSearch$ = new Subject<string>();
  /** Subject privado para el debounce del input de hotel en Block 4. */
  private hotelSuggestDebounce$ = new Subject<string>();
  private destroy$ = new Subject<void>();

  /**
   * ViewChild del <mat-autocomplete> del campo hotelsName.
   */
  @ViewChild('autoHotelsName') autoHotelsName?: MatAutocomplete;
  /**
   * ViewChild del <mat-autocomplete> del campo destination.
   */
  @ViewChild('autoDestination') autoDestination?: MatAutocomplete;
  /**
   * ViewChild del MatAutocompleteTrigger del input hotelsName.
   * Sirve para cerrar programáticamente el dropdown cuando se abre
   * el selector extendido de "¿No encuentra el hotel?".
   */
  @ViewChild('hotelsNameTrigger', { read: MatAutocompleteTrigger })
  hotelsNameTrigger?: MatAutocompleteTrigger;
  /**
   * ViewChild del MatAutocompleteTrigger del input hotelSuggest (Block 4).
   * Sirve para abrir programáticamente el panel cuando llegan resultados.
   */
  @ViewChild('hotelSuggestInput', { read: MatAutocompleteTrigger })
  hotelSuggestInput?: MatAutocompleteTrigger;
    constructor(
          // Opcionales: el componente se usa tanto dentro de un MatDialog
          // (flujo actual) como embebido en una página (`/offline-quote`),
          // donde no existen estos tokens.
          @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
          @Optional() public dialogRef: MatDialogRef<FormOfflineComponent>,
          private formBuilder: FormBuilder,
          private notificationService: NotificationService,
          private userService: UserService,
          public dialog: MatDialog,
          private formService: FormOfflineService,
          private restService: RestService,
          private modalService: BsModalService,
          public spinner: NgxSpinnerService,
    ) { this.dpConfig = {
      dateInputFormat: 'DD/MM/YYYY'
    };
    // Mismo patrón que hotels.component.ts:185 — instanciamos el service
    // acá y lo marcamos como categoría "hotel" para que el tooltip cuente
    // noches, no días.
    this.calendarSyncOffline = new DateRangePickerService();
    this.calendarSyncOffline.setCategory(true);

    // Debounce de 500ms para el input de hotel del Block 4. La búsqueda
    // se dispara automáticamente cuando el usuario deja de tipear.
    this.hotelSuggestDebounce$
      .pipe(
        debounceTime(500),
        distinctUntilChanged(),
        takeUntil(this.destroy$)
      )
      .subscribe((name) => {
        const trimmed = (name || '').trim();
        if (trimmed) {
          this.runHotelSuggestSearch();
        } else {
          // Si el usuario borró el texto, limpiamos resultados sin disparar GET.
          this.hotelSuggestResults = [];
          this.hotelSuggestError = null;
        }
      });
  }

  ngOnInit(): void {
   // OJO: `ngx-daterangepicker-material` v5 solo acepta un objeto **dayjs**
   // (o un string) en minDate/maxDate: si se le pasa un Date nativo o un
   // moment, el setter los descarta en silencio (`_minDate = null`) y el
   // calendario deja habilitar fechas pasadas. Por eso van en dayjs.
   this.minDate = dayjs().startOf('day');
   this.maxDateOffline = dayjs().add(12, 'month');

    // Moneda de la agencia. Prioriza lo que el invocador pasó por MAT_DIALOG_DATA
    // (consistente con el patrón de clientSetting/editData), cae a la del usuario
    // logueado y por último a ARS como fallback. Se usa en los 2 inputs de precio
    // del modal (líneas 856 y 1284 del template) para mostrar el código correcto
    // en lugar del literal "ARS" hardcodeado, y se manda en el payload de la
    // solicitud (buildPayloadHotel) para que el backend sepa la moneda de los
    // importes que carga el operador.
    this.currencyCode = this.data?.currencyAgency?.code
      ?? this.userService.currency?.code
      ?? 'ARS';

    this.clientSetting = this.data?.clientSetting ?? this.clientSetting ?? {};
    this.edit = this.data?.edit ? true : false;
    this.editData = this.data?.editData;
    this.reopen = this.data?.reopen ? true : false;
    const bookingFlow_sidebar = JSON.parse(this.clientSetting?.clients_setting_app_booking?.bookingFlow_sidebar ?? '{}');
    this.backgroundSelect = JSON.parse(this.clientSetting?.clients_setting_app_booking?.bookingFlow_body ?? '{}').card_background_price;
    this.buttonColorActive = bookingFlow_sidebar?.background_color_header;
    this.buttonTextActive = bookingFlow_sidebar?.color;
    if(this.edit && this.editData) {
      this.tabActive(this.editData.category);
      switch(this.editData.category) {
        case 'hotels':
          this.initFormHotel();
        break;
        case 'transfers':
          this.initFormTransfer();
          break;
        case 'rentacar':
          this.initFormRentACar();
          break;
      }
    }
    if(!this.edit) {
      this.tab = 'hotel';
      this.initFormHotel();
      this.initFormTransfer();
      this.initFormRentACar();
      this.initFormExperience();

      // Si el invocador pasó datos del formulario de búsqueda (ej: hotels.component.ts),
      // pre-rellenamos los campos comunes del formHotel.
      if (this.data?.prefill) {
        this.prefillHotelFromSearch(this.data.prefill);
      }

      // Prefill file/client from active itinerary (header opens modal directly).
      // NO se aplica acá: `existingFiles` todavía está vacío (la carga es HTTP)
      // y sin la lista real no se puede resolver el label ni los clientes del
      // file. La aplicación se hace en `applyPendingPrefillFile()`, que corre
      // cuando la lista termina de cargar.
      this.pendingPrefillFileId = (this.data?.prefillFile ?? this.prefillFile)?.id ?? null;

      // Cargar la lista de files/itineraries existentes para el selector.
      this.loadExistingFiles();

      // Setup del autocomplete de "Nombre de hoteles".
      this.setupHotelsNameAutocomplete();
      // Setup del autocomplete de "Destino".
      this.setupDestinationAutocomplete();
      // Carga países para el autocomplete de phone_code del cliente.
      this.loadCountries();
    }
  }

  /**
   * Pre-rellena los campos del formHotel con los valores del formulario
   * de búsqueda de hoteles cuando se abre el modal desde el flujo de
   * "Solicitud offline".
   *
   * Solo se invoca cuando `!edit` (modo creación, no edición).
   *
   * IMPORTANTE: marca `formHotelEdited = true` para que `onSubmit` incluya
   * el producto hotel en el payload. Si quedara en `false`, el componente
   * asumiría que el usuario no tocó nada y omitiría el envío.
   *
   * @param prefill Objeto con: destination, arrivalDepartureDate, nationality,
   *                adults, childs, age_childs, qty_rooms.
   */
  prefillHotelFromSearch(prefill: any): void {
    if (!prefill) {
      return;
    }

    if (prefill.arrivalDepartureDate?.start && prefill.arrivalDepartureDate?.end) {
      this.dateRange = {
        start: prefill.arrivalDepartureDate.start,
        end: prefill.arrivalDepartureDate.end
      };
    }

    this.formHotel.patchValue({
      destination: prefill.destination ?? null,
      nationality: prefill.nationality ?? null,
    });

    // La nacionalidad viene del buscador (ya viene elegida), no de un texto
    // tipeado en este form: se marca como selección válida.
    this.nationalitySelected = !!prefill.nationality;
    this.formHotel.get('nationality')?.updateValueAndValidity();

    // Reconstruir FormArray room desde datos planos
    const adults = prefill.adults ?? 2;
    const childs = prefill.childs ?? 0;
    const qtyRooms = prefill.qty_rooms ?? 1;
    const agesStr = prefill.age_childs ?? '';
    const ages = agesStr ? agesStr.split(',').map((a: string) => parseInt(a.trim(), 10)).filter((a: number) => !isNaN(a)) : [];

    const roomArray = this.formHotel.get('room') as FormArray;
    roomArray.clear();

    const adultsPerRoom = Math.ceil(adults / qtyRooms);
    const childsPerRoom = Math.ceil(childs / qtyRooms);

    for (let i = 0; i < qtyRooms; i++) {
      const roomAdults = Math.min(adultsPerRoom, adults - (i * adultsPerRoom));
      const roomChilds = Math.min(childsPerRoom, childs - (i * childsPerRoom));

      const childsageArray = this.formBuilder.array([]);
      for (let j = 0; j < roomChilds; j++) {
        const ageIndex = i * childsPerRoom + j;
        const age = ages[ageIndex] ?? 0;
        childsageArray.push(this.formBuilder.group({
          id: [j],
          age: [age, [Validators.required, Validators.min(0), Validators.max(17)]]
        }));
      }

      roomArray.push(this.createRoomGroup(
        roomAdults > 0 ? roomAdults : 1,
        roomChilds,
        childsageArray
      ));
    }

    this.clampActiveRoomTab();
    this.setRoomAndPassengers();
    this.formHotelEdited = true;
  }

  isInvalidDate = (m: dayjs.Dayjs) => {
  // El callback lo invoca el daterangepicker con un objeto dayjs.
  return m.isBefore(this.minDate, 'day');
}

  /**
   * Acción del botón "Solicitar cotización" del hero: lleva al usuario
   * hasta el formulario (las tabs), que es donde se completa la solicitud.
   *
   * Respeta `prefers-reduced-motion`: si el usuario pidió menos animación,
   * el scroll es instantáneo.
   */
  scrollToQuotationForm(): void {
    const target = this.quotationFormAnchor?.nativeElement;
    if (!target) {
      return;
    }
    const reduceMotion = typeof window !== 'undefined'
      && typeof window.matchMedia === 'function'
      && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
    // `scrollIntoView` no mueve el foco: lo hacemos nosotros para que el
    // teclado quede en el formulario y no en el botón del hero.
    target.focus?.();
  }

  tabActive(tab: string) {
    switch(tab) {
      case 'hotel':
        this.tab = 'hotel';
        break;
      case 'hotels':
        this.tab = 'hotel';
        break;
      case 'transfer':
        this.tab = 'transfer';
        break;
      case 'transfers':
        this.tab = 'transfer';
        break;
      case 'experience':
        this.tab = 'experience';
        break;
      case 'experiencia':
        this.tab = 'experience';
        break;
      case 'ticket':
        this.tab = 'ticket';
        break;
      case 'tickets':
        this.tab = 'ticket';
        break;
    }
  }

  initFormHotel(): void {
    this.formHotel = this.formBuilder.group({
      destination:  new FormControl(null, [Validators.required, Validators.minLength(3),Validators.maxLength(80)]),
      // arrivalDepartureDate es el control bindeado al ngxDaterangepickerMd
      // (start/end). Sin este FormControl en el FormGroup, Angular tira
      // "Cannot find control with name: 'arrivalDepartureDate'" cuando el
      // picker emite (startDateChanged), y eso rompe la cadena de eventos
      // del daterangepicker — incluido el tooltip "X días / X noches".
      // Es required: el usuario tiene que elegir check-in y check-out.
      // Usamos un validator custom porque `Validators.required` solo no
      // alcanza: cuando el daterangepicker está vacío, el value es
      // {start: null, end: null} (un objeto truthy, no null), así que
      // required lo da por válido. El validator custom chequea que ambos
      // extremos tengan fecha.
      arrivalDepartureDate: new FormControl(null, (c) => {
        const v = c?.value;
        if (!v || typeof v !== 'object') {
          return { required: true };
        }
        if (!v.start || !v.end) {
          return { required: true };
        }
        // Además de que estén los dos extremos, el check-in no puede ser
        // anterior a hoy.
        return this.dateRangeNotPastValidator(c);
      }),
      hotelNames: this.formBuilder.array([this.formBuilder.group({ name: new FormControl('', [Validators.required, Validators.maxLength(100)]) })]),
      star: new FormArray([]),
      room: this.formBuilder.array([]),
      price_night: new FormControl(null, this.priceNightMaxValidator()),
      estimatedRate: new FormControl({ value: null, disabled: true }),
      category: new FormArray([]),
      type_bed: new FormArray([]),
      meals: new FormArray([]),
      roomConfiguration: new FormControl(null),
      nationality: new FormControl(null, [Validators.minLength(3), Validators.maxLength(50), this.nationalityValidator]),
      comment_contact: new FormControl(null, [Validators.minLength(3), Validators.maxLength(500)]),
      client: this.formBuilder.group({
        client_id: new FormControl(null),
        title: new FormControl(null),
        first_name: new FormControl(null, [Validators.minLength(2), Validators.pattern(/^[a-zA-ZÀ-ÿ\u00f1\u00d1\s]+$/)]),
        last_name: new FormControl(null),
        email: new FormControl(null, [Validators.email]),
        phone_code: new FormControl(null),
        phone: new FormControl(null, [Validators.pattern(/^[0-9]{6,}$/)])
      }),
      passenger: this.formBuilder.group({
        id: [null],
        first_name: ['', Validators.required],
        last_name: ['', Validators.required],
        type: ['']
      }, { validator: this.passengerValidator }),
      requestType: new FormControl('quotation', Validators.required),
      // El `fileName` se autocompleta con el label legible del file
      // (ej: "offline request (#900800) — eddy chambi"). El límite es amplio
      // para no invalidar el form (y bloquear el envío) con títulos largos.
      fileName: new FormControl(null, [Validators.maxLength(120)]),
      file_id: new FormControl(null, Validators.required),
      cancellationPolicy: new FormControl(null)
    });

    const initialHotelValue = this.formHotel.getRawValue();

    this.formHotel.valueChanges.subscribe(currentValue => {
      if (JSON.stringify(currentValue) !== JSON.stringify(initialHotelValue)) {
        this.formHotelEdited = true;
      }
    });

    this.formHotel.get('file_id')!.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe((value: any) => {
        if (value) {
          this.loadPaxForFile(value);
        } else {
          this.availablePax = [];
        }
        this.formHotel.get('passenger')!.reset({ id: null, first_name: '', last_name: '', type: '' });
      });

    this.formHotel.get('requestType')!.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe((currentRequestType: any) => {
        this.formHotel.get('passenger')!.reset({ id: null, first_name: '', last_name: '', type: '' });
        // El pasajero solo es requerido cuando NO es cotización: en `quotation`
        // el <select> de pasajeros está oculto (request-header *ngIf), por lo
        // que `first_name` y `last_name` nunca se tipean y dejaban el form
        // `invalid` para siempre. Mismo criterio que usa `buildPayloadHotel`:
        // el bloque `raw.passenger` solo se incluye si `requestType !== 'quotation'`.
        const passengerGroup = this.formHotel.get('passenger') as FormGroup;
        if (!passengerGroup) return;
        if (currentRequestType === 'quotation') {
          passengerGroup.get('first_name')?.clearValidators();
          passengerGroup.get('last_name')?.clearValidators();
        } else {
          passengerGroup.get('first_name')?.setValidators([Validators.required]);
          passengerGroup.get('last_name')?.setValidators([Validators.required]);
        }
        passengerGroup.get('first_name')?.updateValueAndValidity();
        passengerGroup.get('last_name')?.updateValueAndValidity();
      });

    this.formHotel.reset();
    this.formHotel.patchValue({ requestType: 'quotation' });
    // Estado inicial consistente con el default `requestType === 'quotation'`:
    // el pasajero NO se tipea (el <select> está oculto), por lo que sus
    // required no deben bloquear la validez del form. La subscripción a
    // `requestType.valueChanges` se encarga del resto de los toggles.
    const initialPassengerGroup = this.formHotel.get('passenger') as FormGroup;
    if (initialPassengerGroup) {
      initialPassengerGroup.get('first_name')?.clearValidators();
      initialPassengerGroup.get('last_name')?.clearValidators();
      initialPassengerGroup.get('first_name')?.updateValueAndValidity();
      initialPassengerGroup.get('last_name')?.updateValueAndValidity();
    }
    // El reset() anterior vacía el FormArray `room`. Lo re-poblamos con la
    // habitación default (1 adulto) para que el form arranque con pasajeros
    // visibles y válidos. En edit mode, patchFormHotel() lo sobreescribe.
    this.addInitialRoom();
    this.formHotelEdited = true;

    if(this.edit && this.editData) {
     this.patchFormHotel(this.editData);
    }
  }

    patchFormHotel(editData: any): void {
      const product = editData?.product || {};
      console.log(product)

      const startDate = product.arrivalDepartureDate?.start
        ? new Date(product.arrivalDepartureDate.start)
        : null;

      const endDate = product.arrivalDepartureDate?.end
        ? new Date(product.arrivalDepartureDate.end)
        : null;

      this.formHotel.patchValue({
        destination: product.destination ?? 'N/A',
        arrivalDepartureDate: startDate && endDate ? { start: startDate, end: endDate } : null,
      });

      if (product.hotelsName) {
        this.hotelNamesArray.at(0).get('name')?.setValue(product.hotelsName);
      }

      this.formHotel.patchValue({
        price_night: product.price_night ?? null,
        nationality: product.nationality ?? 'N/A',
        comment_contact: product.comment_contact ?? 'No hay comentarios',
        client: {
          client_id: editData?.client_id ?? null,
          title: editData?.client?.title ?? null,
          first_name: editData?.client?.first_name ?? null,
          last_name: editData?.client?.last_name ?? null,
          email: editData?.client?.email ?? null,
          phone_code: editData?.client?.phone_code ?? null,
          phone: editData?.client?.phone ?? null
        },
        requestType: editData?.requestType ?? product?.requestType ?? null,
        fileName: product?.fileName ?? editData?.fileName ?? null,
        file_id: product?.file_id ?? editData?.file_id ?? null,
        cancellationPolicy: product?.cancellationPolicy ?? null
      });

      // La nacionalidad viene del backend (no de una selección del agente), así
      // que se marca como valor válido: si no, el validador la daría por
      // inválida en el modo reabrir (form habilitado).
      this.nationalitySelected = true;
      this.formHotel.get('nationality')?.updateValueAndValidity();

      // Formatear el input de tarifa con el valor numerico que vino del backend.
      setTimeout(() => this.formatPriceNightInput(product.price_night ?? null), 0);

      // Valor estimado por noche: se repuebla con el que venia guardado para
      // que al reabrir y reenviar la solicitud no se pierda (el control es
      // disabled, asi que no se repopla solo).
      //
      // `parseAmountEnUs` tolera que el backend lo mande como numero (12) o
      // como string ("12.00" / "1,234.50"): el control guarda la version
      // formateada para mostrar y el payload vuelve a mandarse como numero.
      const estimatedRate = parseAmountEnUs(product.estimated_rate);
      if (estimatedRate !== null) {
        this.setEstimatedRateValue(estimatedRate);
        // Sin esto la UI mostraria "Sin valor de referencia" con el valor
        // dentro del input, porque el flag solo lo setea la respuesta del
        // endpoint (que en edit no se vuelve a pedir).
        this.hasReferentialCost = true;
      }

      // Reconstruir FormArray room desde lo que guardo el backend.
      //
      // Las solicitudes nuevas traen el array `room` tal como lo mandamos
      // (con la ocupacion y las preferencias de cada habitacion), asi que se
      // rehidrata desde ahi. Las viejas solo tienen los totales planos
      // (adults/childs/age_childs/qty_rooms) y se reparten entre las
      // habitaciones como antes.
      const adults = product.adults ?? 1;
      const childs = product.childs ?? 0;
      const qtyRooms = product.qty_rooms ?? 1;
      const agesStr = product.age_childs ?? '';
      const ages = agesStr && agesStr !== 'N/A' ? agesStr.split(',').map((a: string) => parseInt(a.trim(), 10)).filter((a: number) => !isNaN(a)) : [];

      // Preferencias legacy (raiz del producto) de las solicitudes anteriores
      // a las preferencias por habitacion. Se reparten en round-robin entre
      // las habitaciones: la union se mantiene intacta al reenviar.
      const legacyMeals = this.preferenceList(product.meals);
      const legacyCategory = this.preferenceList(product.category);
      const legacyTypeBed = this.preferenceList(product.type_bed);
      const legacyPolicy: string | null = product.cancellationPolicy ?? null;

      const storedRooms: any[] = Array.isArray(product.room)
        ? product.room.filter((r: any) => r && typeof r === 'object')
        : [];

      const roomArray = this.formHotel.get('room') as FormArray;
      roomArray.clear();

      if (storedRooms.length > 0) {
        storedRooms.forEach((stored: any, index: number) => {
          const childsageArray = this.formBuilder.array([]);
          (stored.childsage || []).forEach((child: any, j: number) => {
            childsageArray.push(this.formBuilder.group({
              id: [child?.id ?? j],
              age: [Number(child?.age) || 0, [Validators.required, Validators.min(0), Validators.max(17)]]
            }));
          });

          const prefs = stored.preferences || {};
          roomArray.push(this.createRoomGroup(
            Number(stored.qtyAdults) || 1,
            stored.qtyChilds != null ? Number(stored.qtyChilds) : (stored.childsage?.length ?? 0),
            childsageArray,
            {
              meals: this.firstPreference(prefs.meals) ?? legacyMeals[index % legacyMeals.length] ?? null,
              category: this.firstPreference(prefs.category) ?? legacyCategory[index % legacyCategory.length] ?? null,
              type_bed: this.firstPreference(prefs.type_bed) ?? legacyTypeBed[index % legacyTypeBed.length] ?? null,
              cancellationPolicy: prefs.cancellationPolicy ?? legacyPolicy
            }
          ));
        });
        console.log('[patchFormHotel] Habitaciones desde product.room:', storedRooms.length);
      } else if (qtyRooms === 1 && adults > 0) {
        // Distribución simple: 1 habitación con todos los adultos
        const childsageArray = this.formBuilder.array([]);
        ages.forEach((age: number, idx: number) => {
          childsageArray.push(this.formBuilder.group({
            id: [idx],
            age: [age, [Validators.required, Validators.min(0), Validators.max(17)]]
          }));
        });
        roomArray.push(this.createRoomGroup(adults, ages.length, childsageArray, {
          meals: legacyMeals[0] ?? null,
          category: legacyCategory[0] ?? null,
          type_bed: legacyTypeBed[0] ?? null,
          cancellationPolicy: legacyPolicy
        }));
        console.log('[patchFormHotel] Distribución simple: 1 habitación con', adults, 'adults y', ages.length, 'niños');
      } else {
        // Distribución: N habitaciones con 1 adulto cada una
        const adultsPerRoom = Math.ceil(adults / qtyRooms);
        const childsPerRoom = Math.ceil(childs / qtyRooms);

        for (let i = 0; i < qtyRooms; i++) {
          const roomAdults = Math.min(adultsPerRoom, adults - (i * adultsPerRoom));
          const roomChilds = Math.min(childsPerRoom, childs - (i * childsPerRoom));

          const childsageArray = this.formBuilder.array([]);
          for (let j = 0; j < roomChilds; j++) {
            const ageIndex = i * childsPerRoom + j;
            const age = ages[ageIndex] ?? 0;
            childsageArray.push(this.formBuilder.group({
              id: [j],
              age: [age, [Validators.required, Validators.min(0), Validators.max(17)]]
            }));
          }

          roomArray.push(this.createRoomGroup(
            roomAdults > 0 ? roomAdults : 1,
            roomChilds,
            childsageArray,
            {
              meals: legacyMeals[i % legacyMeals.length] ?? null,
              category: legacyCategory[i % legacyCategory.length] ?? null,
              type_bed: legacyTypeBed[i % legacyTypeBed.length] ?? null,
              cancellationPolicy: legacyPolicy
            }
          ));
        }
        console.log('[patchFormHotel] Distribución múltiples:', qtyRooms, 'habitaciones');
      }

      this.setRoomAndPassengers();
      this.clampActiveRoomTab();

      // Hidratar el chip de nacionalidad. Solo si hay un valor real: 'N/A' es
      // el placeholder del patchValue, no un país seleccionado.
      const editNationality = product.nationality;
      if (editNationality && editNationality !== 'N/A') {
        this.selectNationalityName = editNationality;
      }

      this.selectedClient = editData?.client ?? null;

      // Hidratar UI state de file y cliente para que el autocomplete y el <select>
      // muestren los valores en edit mode (read-only). Sin esto, los inputs quedan
      // vacíos aunque `formHotel` esté correctamente patcheado.
      const editFileId = product?.file_id ?? editData?.file_id ?? null;
      const editFileName = product?.fileName ?? editData?.fileName ?? null;
      if (editFileId != null || editFileName) {
        const syntheticFile = {
          id: editFileId,
          name: editFileName,
          __synthetic: true,
          clients: editData?.client ? [editData.client] : []
        };
        this.selectedFile = syntheticFile;
        this.selectedFileId = editFileId;
        this.fileAutocompleteModel = editFileName ?? syntheticFile;
      }

      const editClientId = editData?.client?.client_id
        ?? editData?.client_id
        ?? editData?.client?.id
        ?? null;
      if (editClientId != null) {
        this.selectedClientId = editClientId;
      }

    // Las preferencias (meals / category / type_bed / cancellationPolicy) ya NO
    // se hidratan en la raiz del form: ahora viven por habitacion y se
    // rehidratan junto con el array `room` (ver arriba). La raiz se calcula
    // al construir el payload, como union de las habitaciones.

        if(product?.star && product?.star.length > 0){
      product.star.forEach((meal: any) => {
        let event = {
          target: {
          checked: true,
          value: meal
        }}
        this.onChangeSelectForm(event,'hotel', 'star');
      })
    }

    if (!this.reopen) {
      this.formHotel.disable();
    }


  };

  /**
   * Grupo de un traslado (uno por cada traslado de la solicitud).
   *
   * Cada traslado tiene su propio origen/destino, horarios, pasajeros y
   * preferencias (por tramo: ida / vuelta). Es el equivalente Angular del
   * `TransferCard` del Lovable.
   */
  createTransferGroup(): FormGroup {
    const group = this.formBuilder.group({
      origin: ['', Validators.required],
      destination: ['', Validators.required],
      pickupDate: ['', Validators.required],
      pickupTime: ['', Validators.required],
      returnDate: [''],
      returnTime: [''],
      adults: ['1', [Validators.required, Validators.min(1)]],
      children: ['0'],
      childAges: this.formBuilder.array([], this.transferChildAgesValidator),
      // Cantidad de vehículos del traslado (Lovable: "Cantidad de vehículos").
      vehicleCount: [1, [Validators.required, Validators.min(1), Validators.max(10)]],
      // Ids de los vuelos asociados al traslado (ver "Vuelos asociados").
      flightIds: this.formBuilder.array([]),
      // Vuelos asociados completos (se guardan en el payload).
      flights: this.formBuilder.array([]),
      // Preferencias del traslado, separadas por tramo: "ida" siempre aplica y
      // "vuelta" sólo se usa cuando el traslado es ida y vuelta (hay fecha de
      // vuelta). Cada tramo tiene su propia modalidad, categoría y tipo de
      // vehículo.
      preferences: this.formBuilder.group({
        ida: this.formBuilder.group({
          modality: this.formBuilder.control([]),
          category: this.formBuilder.control([]),
          vehicles: this.formBuilder.control([])
        }),
        vuelta: this.formBuilder.group({
          modality: this.formBuilder.control([]),
          category: this.formBuilder.control([]),
          vehicles: this.formBuilder.control([])
        })
      }),
      comments: ['', Validators.maxLength(1000)]
    }, { validators: this.transferDateRangeValidator });

    // El array de edades tiene que seguir la cantidad de niños: cada niño
    // necesita su edad (validador `transferChildAgesValidator`).
    group.get('children')?.valueChanges.subscribe((value: any) => {
      const childAges = group.get('childAges') as FormArray;
      const count = Math.max(0, Math.floor(Number(value) || 0));
      while (childAges.length < count) {
        childAges.push(this.formBuilder.control(''));
      }
      while (childAges.length > count) {
        childAges.removeAt(childAges.length - 1);
      }
    });

    return group;
  }

  initFormTransfer(): void {
    this.formTransfer = this.formBuilder.group({
      requestType: ['quotation', Validators.required],
      file_id: ['', Validators.required],
      fileName: [''],
      client: this.formBuilder.group({
        client_id: ['', Validators.required],
        first_name: [''],
        last_name: [''],
        email: [''],
        phone_code: [''],
        phone: ['']
      }),
      passenger: this.formBuilder.group({
        id: [''],
        first_name: [''],
        last_name: ['']
      }, { validators: this.transferPassengerValidator }),
      // Traslados: un grupo por traslado (modelo repetible del Lovable).
      // El array es obligatorio: la solicitud tiene que tener al menos un
      // traslado cargado.
      transfers: this.formBuilder.array([this.createTransferGroup()], Validators.required),
      // Vuelos cargados a mano por el agente. Son compartidos por todos los
      // traslados de la solicitud (Lovable: los vuelos manuales quedan
      // disponibles para los demás traslados del file).
      manualFlights: this.formBuilder.array([]),
      // Bloque "Competencia / disparidad tarifaria": enlaces de referencia y
      // capturas adjuntas (base64) que se envían como `competitors`.
      competitorUrls: this.formBuilder.array([this.formBuilder.control('')]),
      competitorImages: this.formBuilder.array([]),
      comments: ['', Validators.maxLength(1000)]
    });

    const initialTransferValue = this.formTransfer.getRawValue();

    this.formTransfer.valueChanges.subscribe(currentValue => {
      if (JSON.stringify(currentValue) !== JSON.stringify(initialTransferValue)) {
        this.formTransferEdited = true;
      }
    });

    // Los vuelos asociados dependen del file seleccionado: cuando cambia, se
    // cargan los vuelos de ese file.
    this.formTransfer.get('file_id')?.valueChanges.subscribe((fileId: any) => {
      this.loadFlightsForFile(fileId);
    });

    // Reset con los valores por defecto del formulario: sin pasajero, un
    // enlace de referencia vacío (como en el diseño React) y un traslado
    // vacío listo para completar.
    this.formTransfer.reset({
      requestType: 'quotation',
      transfers: [],
      competitorUrls: [''],
      competitorImages: [],
      comments: ''
    });
    const transfersArray = this.formTransfer.get('transfers') as FormArray;
    transfersArray.clear();
    transfersArray.push(this.createTransferGroup());
    this.formTransferEdited = false;

    if(this.edit && this.editData) {
        this.patchFormTransfer(this.editData);
    }
  }

  patchFormTransfer(editData: any): void {
      const product = editData?.product || {};
      console.log(product)

      this.formTransfer.patchValue({
        requestType: editData?.requestType ?? product?.requestType ?? 'quotation',
        file_id: product?.file_id ?? editData?.file_id ?? null,
        fileName: product?.fileName ?? editData?.fileName ?? null,
        client: {
          client_id: editData?.client_id ?? null,
          first_name: editData?.client?.first_name ?? null,
          last_name: editData?.client?.last_name ?? null,
          email: editData?.client?.email ?? null,
          phone_code: editData?.client?.phone_code ?? null,
          phone: editData?.client?.phone ?? null
        },
        passenger: {
          id: editData?.passenger?.id ?? null,
          first_name: editData?.passenger?.first_name ?? null,
          last_name: editData?.passenger?.last_name ?? null
        },
        comments: product.comments ?? ''
      });

      // Traslados: si el producto tiene el array `transfers` (modelo repetible)
      // se rehidrata uno por uno; si no, se arma uno solo con los campos
      // planos que guardaba el modelo anterior.
      this.patchTransferList(product);

      // Vuelos cargados a mano (compartidos por todos los traslados).
      const manualFlights = this.formTransfer.get('manualFlights') as FormArray;
      if (manualFlights) {
        manualFlights.clear();
        (Array.isArray(product?.manualFlights) ? product.manualFlights : []).forEach((flight: any) => {
          manualFlights.push(this.formBuilder.control(flight));
        });
      }

      // Competencia / disparidad tarifaria: los enlaces y las capturas que
      // ya tenía la solicitud (vienen dentro de `competitors`).
      this.patchTransferCompetitors(product?.competitors ?? []);

       if (!this.reopen) {
        this.formTransfer.disable();
      }
  }

  /**
   * Rehidrata el FormArray `transfers` a partir del producto guardado.
   *
   * - Si el producto tiene `transfers` (array), se crea un traslado por cada
   *   elemento.
   * - Si no (solicitudes viejas, que guardaban un solo traslado en la raíz),
   *   se arma un único traslado con esos campos.
   */
  private patchTransferList(product: any): void {
    const transfersArray = this.formTransfer.get('transfers') as FormArray;
    transfersArray.clear();

    const storedTransfers: any[] = Array.isArray(product?.transfers) && product.transfers.length > 0
      ? product.transfers
      : [{
          origin: product?.origin,
          destination: product?.destination,
          pickupDate: product?.pickupDate,
          pickupTime: product?.pickupTime,
          returnDate: product?.returnDate,
          returnTime: product?.returnTime,
          adults: product?.adults,
          children: product?.children,
          childAges: product?.childAges,
          preferences: product?.preferences,
          modality: product?.modality,
          category: product?.category,
          vehicles: product?.vehicles,
          comments: product?.comments
        }];

    storedTransfers.forEach((stored: any) => {
      const group = this.createTransferGroup();
      const returnDate = stored?.returnDate ? this.toIsoDate(stored.returnDate) : null;

      group.patchValue({
        origin: stored?.origin ?? '',
        destination: stored?.destination ?? '',
        pickupDate: stored?.pickupDate ? this.toIsoDate(stored.pickupDate) : '',
        pickupTime: stored?.pickupTime ?? '',
        returnDate: returnDate ?? '',
        returnTime: stored?.returnTime ?? '',
        adults: String(stored?.adults ?? '1'),
        children: String(stored?.children ?? '0'),
        vehicleCount: String(stored?.vehicleCount ?? '1'),
        comments: stored?.comments ?? '',
        preferences: {
          // Fallback: las solicitudes viejas guardaban las preferencias en la
          // raiz del producto (sin separar por tramo). En ese caso se aplican
          // a ambos tramos.
          ida: {
            modality: stored?.preferences?.ida?.modality ?? stored?.modality ?? [],
            category: stored?.preferences?.ida?.category ?? stored?.category ?? [],
            vehicles: stored?.preferences?.ida?.vehicles ?? stored?.vehicles ?? []
          },
          vuelta: {
            modality: stored?.preferences?.vuelta?.modality ?? (returnDate ? stored?.modality ?? [] : []),
            category: stored?.preferences?.vuelta?.category ?? (returnDate ? stored?.category ?? [] : []),
            vehicles: stored?.preferences?.vuelta?.vehicles ?? (returnDate ? stored?.vehicles ?? [] : [])
          }
        }
      });

      // Edades de los niños: el array se rehidrata desde el producto para que
      // los contadores de pasajeros y los selects de edad queden consistentes
      // en el modo edición / reapertura.
      const childAgesArray = group.get('childAges') as FormArray;
      childAgesArray.clear();
      (Array.isArray(stored?.childAges) ? stored.childAges : []).forEach((age: any) => {
        childAgesArray.push(this.formBuilder.control(age === null || age === undefined ? '' : String(age)));
      });

      // Vuelos asociados: se guardan los ids y los objetos completos.
      const flightIdsArray = group.get('flightIds') as FormArray;
      flightIdsArray.clear();
      (Array.isArray(stored?.flightIds) ? stored.flightIds : []).forEach((id: any) => {
        flightIdsArray.push(this.formBuilder.control(String(id)));
      });
      const flightsArray = group.get('flights') as FormArray;
      flightsArray.clear();
      (Array.isArray(stored?.flights) ? stored.flights : []).forEach((flight: any) => {
        flightsArray.push(this.formBuilder.control(flight));
      });

      transfersArray.push(group);
    });
  }

  /**
   * Reconstruye los FormArray de enlaces y capturas con lo que ya tenía la
   * solicitud. Las capturas guardadas llegan como url pública.
   */
  private patchTransferCompetitors(competitors: any[]): void {
    const urls = this.formTransfer.get('competitorUrls') as FormArray;
    const images = this.formTransfer.get('competitorImages') as FormArray;

    urls.clear();
    images.clear();

    (competitors || []).forEach((competitor: any) => {
      urls.push(this.formBuilder.control(competitor?.url ?? ''));
      (competitor?.images ?? []).forEach((image: any, index: number) => {
        images.push(this.formBuilder.control({ name: `Captura ${index + 1}`, image }));
      });
    });

    if (urls.length === 0) {
      urls.push(this.formBuilder.control(''));
    }
  }

  /** Normaliza una fecha a YYYY-MM-DD (ISO). */
  private toIsoDate(value: any): string | null {
    if (!value) return null;
    if (typeof value === 'string') {
      const iso = /^(\d{4})-(\d{2})-(\d{2})/.exec(value.trim());
      if (iso) return `${iso[1]}-${iso[2]}-${iso[3]}`;
      const parsed = new Date(value);
      if (isNaN(parsed.getTime())) return null;
      return parsed.toISOString().slice(0, 10);
    }
    const date = value instanceof Date ? value : new Date(value);
    if (isNaN(date.getTime())) return null;
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    return `${date.getFullYear()}-${month}-${day}`;
  }

  initFormRentACar(): void {
    this.formRentACar = this.formBuilder.group({
      origin: new FormControl(null, [Validators.required, Validators.minLength(3), Validators.maxLength(50)]),
      pickupDate: new FormControl(null, Validators.required),
      pickupTimeDay: new FormArray([], Validators.required),
      destinationReturn: new FormControl(null, [Validators.minLength(3), Validators.maxLength(50)]),
      dropoffDate: new FormControl(null, Validators.required),
      dropoffTimeDay: new FormArray([], Validators.required),
      vehicleType: new FormArray([]),
      transmissionType: new FormArray([]),
      adults: new FormControl(null, [Validators.required, Validators.min(1), Validators.max(99)]),
      childs: new FormControl(null,  [ Validators.min(0), Validators.max(99)]),
      age_childs: new FormControl(null),
      comment_contact: new FormControl(null, [Validators.minLength(3), Validators.maxLength(500)])
    })

    this.formRentACar.valueChanges.subscribe(() => {
      this.formRentACarEdited = true;
    });

    this.formRentACar.get('childs').valueChanges.subscribe((value: any) => {
      if(value > 0) {
        this.formRentACar.get('age_childs').setValidators(Validators.required);
      } else if (value === 0 || value === '' || value === null) {
         this.formRentACar.get('age_childs').clearValidators();
      }
       this.formRentACar.get('age_childs').updateValueAndValidity();
    });

    this.formRentACar.reset();
    this.formRentACarEdited = false;

      if(this.edit && this.editData) {
        this.patchFormRentACar(this.editData);
    }
  }

  patchFormRentACar(editData: any): void {
      const product = editData?.product || {};
      console.log(product)

      const pickupDate = product.pickupDate
        ? new Date(product.pickupDate)
        : null;

      const dropoffDate = product.dropoffDate
        ? new Date(product.dropoffDate)
        : null;

      this.formRentACar.patchValue({
        origin: product?.origin,
        pickupDate: pickupDate,
        destinationReturn: product.destinationReturn ?? 'N/A',
        dropoffDate: dropoffDate,
        adults: product?.adults,
        childs: product?.childs,
        age_childs: product?.age_childs ?? 'N/A',
        comment_contact: product?.comment_contact ?? 'No hay comentarios'
    });

      if(product?.pickupTimeDay && product?.pickupTimeDay.length > 0){
            product.pickupTimeDay.forEach((meal: any) => {
              let event = {
                target: {
                checked: true,
                value: meal
              }}
              this.onChangeSelectForm(event,'rent-a-car', 'pickupTimeDay');
            })
      }

        if(product?.dropoffTimeDay && product?.dropoffTimeDay.length > 0){
            product.dropoffTimeDay.forEach((meal: any) => {
              let event = {
                target: {
                checked: true,
                value: meal
              }}
              this.onChangeSelectForm(event,'rent-a-car', 'dropoffTimeDay');
            })
      }

        if(product?.vehicleType && product?.vehicleType.length > 0){
            product.vehicleType.forEach((meal: any) => {
              let event = {
                target: {
                checked: true,
                value: meal
              }}
              this.onChangeSelectForm(event,'rent-a-car', 'vehicleType');
            })
      }

        if(product?.transmissionType && product?.transmissionType.length > 0){
            product.transmissionType.forEach((meal: any) => {
              let event = {
                target: {
                checked: true,
                value: meal
              }}
              this.onChangeSelectForm(event,'rent-a-car', 'transmissionType');
            })
      }

       console.log(this.formRentACar)
      if (!this.reopen) {
        this.formRentACar.disable();
      }

  }

  initFormExperience(): void {
    this.formExperience = this.formBuilder.group({
      requestType: ['quotation', Validators.required],
      file_id: ['', Validators.required],
      fileName: [''],
      client: this.formBuilder.group({
        client_id: ['', Validators.required],
        first_name: [''],
        last_name: [''],
        email: [''],
        phone_code: [''],
        phone: ['']
      }),
      passenger: this.formBuilder.group({
        id: [''],
        first_name: [''],
        last_name: ['']
      }, { validators: this.experiencePassengerValidator }),
      destination: ['', Validators.required],
      checkIn: ['', Validators.required],
      checkOut: ['', Validators.required],
      adults: [2, [Validators.required, Validators.min(1)]],
      children: [0, [Validators.min(0)]],
      childAges: this.formBuilder.array([]),
      budget: [''],
      nationality: [''],
      type: ['', Validators.required],
      details: this.formBuilder.group({}),
      cancellation: [[]],
      expanded: [false],
      searchNotes: [''],
      comments: ['']
    }, { validators: this.dateRangeValidator });
  }

  private dateRangeValidator(group: AbstractControl): ValidationErrors | null {
    const checkIn = group.get('checkIn')?.value;
    const checkOut = group.get('checkOut')?.value;
    if (checkIn && checkOut && checkOut < checkIn) {
      return { dateRange: true };
    }
    return null;
  }

  /**
   * Debug helper: loguea cada control inválido de un FormGroup con su path,
   * errores de validación y valor actual. Pensado para `onSubmit()` cuando
   * algún form no valida y el usuario reporta "no me deja crear".
   */
  private logInvalidControls(prefix: string, group: FormGroup): void {
    const collect = (control: AbstractControl, path: string, acc: { path: string; errors: any; value: any }[]) => {
      if (control instanceof FormGroup) {
        Object.keys((control as FormGroup).controls).forEach(k => {
          collect((control as FormGroup).get(k), path ? `${path}.${k}` : k, acc);
        });
      } else if (control instanceof FormArray) {
        (control as FormArray).controls.forEach((c, i) => collect(c, `${path}[${i}]`, acc));
      } else if (control.invalid) {
        acc.push({ path, errors: control.errors, value: control.value });
      }
    };
    const invalid: { path: string; errors: any; value: any }[] = [];
    collect(group, '', invalid);
    // eslint-disable-next-line no-console
    console.groupCollapsed(`[form-offline] ${prefix} — ${invalid.length} control(es) inválido(s)`);
    // eslint-disable-next-line no-console
    console.log('[form-offline] invalid controls:', invalid);
    // eslint-disable-next-line no-console
    console.log('[form-offline] form raw value:', group.getRawValue());
    // eslint-disable-next-line no-console
    console.groupEnd();
  }

  onSubmit(): void {
    const payload: any = {
      client_id: this.userService.clientIdFusion,
      agency_id: this.userService._agencyID,
      agent_id: this.userService._agentID,
      requestType: this.formHotel.get('requestType')?.value ?? null,
      products: {}
    }

    if (this.formHotelEdited) {
      if(this.formHotel.valid) {
        // client.client_id, file_id, requestType son Validators.required, así
        // que `formHotel.valid` ya garantiza que están completos. La validación
        // manual de cliente/requestType se removió porque quedaba inalcanzable.
        payload.products.hotels = this.buildPayloadHotel();
        const dateRange = payload.products.hotels.arrivalDepartureDate;
        if (dateRange?.start && dateRange?.end) {
          dateRange.start = this.toDateString(dateRange.start);
          dateRange.end = this.toDateString(dateRange.end);
        }
        // eslint-disable-next-line no-console
        console.log('[form-offline] hotel payload built:', payload.products.hotels);
      } else {
        this.logInvalidControls('hotel', this.formHotel);
        const scope = (document.querySelector('.form-offline-wrapper') ?? document.body) as HTMLElement;
        const missingHotel = markFormInvalid(this.formHotel, 'hotel');
        const message = missingHotel.length > 0
          ? `Faltan datos en el hotel: ${missingHotel.map(m => m.label).join(', ')}`
          : 'Faltan datos en el formulario de hotel';
        this.notificationService.info(message);
        setTimeout(() => scrollToFirstInvalid(scope, 'hotel'), 0);
        return;
      }
    }

    if (this.formTransferEdited) {
      if(this.formTransfer.valid) {
          // Las fechas de cada traslado ya salen formateadas desde
          // `buildPayloadTransfer()` (incluidos los campos planos del primer
          // traslado, que son los mismos objetos).
          payload.products.transfers = this.buildPayloadTransfer();
          // eslint-disable-next-line no-console
          console.log('[form-offline] transfer payload built:', payload.products.transfers);
      } else {
        this.logInvalidControls('transfer', this.formTransfer);
        const scope = (document.querySelector('.form-offline-wrapper') ?? document.body) as HTMLElement;
        const missingTransfer = markFormInvalid(this.formTransfer, 'transfer');
        const message = missingTransfer.length > 0
          ? `Faltan datos en el traslado: ${missingTransfer.map(m => m.label).join(', ')}`
          : 'Faltan datos en el formulario de traslado';
        this.notificationService.info(message);
        setTimeout(() => scrollToFirstInvalid(scope, 'transfer'), 0);
        return;
      }
    }

    if (this.formRentACarEdited) {

      if(this.formRentACar.valid) {
          payload.products.rentacar = this.buildPayloadRentACar();
          // eslint-disable-next-line no-console
          console.log(payload.products.rentacar)
          let pickupDate = payload.products.rentacar.pickupDate;
          let dropoffDate = payload.products.rentacar?.dropoffDate ?? null;
          if (pickupDate) {
            pickupDate = this.toDateString(pickupDate);
          }
          if(dropoffDate) {
            dropoffDate = this.toDateString(dropoffDate);
          }
          payload.products.rentacar.pickupDate = pickupDate;
          payload.products.rentacar.dropoffDate = dropoffDate;
          // eslint-disable-next-line no-console
          console.log('[form-offline] rentacar payload built:', payload.products.rentacar);
      } else {
        this.logInvalidControls('rent-a-car', this.formRentACar);
        const scope = (document.querySelector('.form-offline-wrapper') ?? document.body) as HTMLElement;
        const missingRent = markFormInvalid(this.formRentACar, 'rentACar');
        const message = missingRent.length > 0
          ? `Faltan datos en rent a car: ${missingRent.map(m => m.label).join(', ')}`
          : 'Faltan datos en el formulario de rent a car';
        this.notificationService.info(message);
        setTimeout(() => scrollToFirstInvalid(scope, 'rentACar'), 0);
        return;
      }
    }


    if(this.formHotelEdited || this.formTransferEdited || this.formRentACarEdited) {
      // eslint-disable-next-line no-console
      console.log('[form-offline] onSubmit payload:', payload);
      // eslint-disable-next-line no-console
      console.log('[form-offline] onSubmit payload (JSON):', JSON.stringify(payload));

      if (this.reopen) {
        // Reabrir: conserva el modal Material original (mensaje: "Reabrir solicitud").
        const dialogRef = this.dialog.open(MaterialModalConfirmComponent, {
          data: {message: 'Reabrir solicitud', type: 'material'},
          width: '450px'
        });

        dialogRef.afterClosed().subscribe((result) => {
          if(result) {
            this.spinner.show();
            const hasProduct = this.formHotelEdited || this.formTransferEdited || this.formRentACarEdited;
            const reopenPayload: any = { status: 1 };
            if (hasProduct) {
              reopenPayload.product = payload.products;
            }
            this.formService.updateRequestOffline(this.editData.detailId, reopenPayload).subscribe({
              next: (res: any) => {
                this.spinner.hide();
                this.notificationService.success('Solicitud reabierta correctamente.');
                this.afterSuccessfulSubmit();
              },
              error: (error: HttpErrorResponse) => {
                this.notificationService.error('Ha ocurrido un error, vuelva a intentarlo más tarde', 'error: ', error.error);
                this.spinner.hide();
              }
            });
          } else {
            this.spinner.hide();
          }
        });
      } else {
        // Crear: confirmación pre-envío usando `ConfirmationModalComponent`.
        // El usuario confirma antes de que se dispare el POST.
        this.openCreatedConfirmationModal(payload);
      }

    } else {
      this.notificationService.info('Complete algún formulario para enviar su solicitud');
    }

  }

  onExperienceSubmit(payload: any): void {
    this.formExperienceEdited = true;
    if (this.formExperience.invalid) {
      const scope = (document.querySelector('.form-offline-wrapper') ?? document.body) as HTMLElement;
      const missing = markFormInvalid(this.formExperience, 'experience');
      const message = missing.length > 0
        ? `Faltan datos en experiencias: ${missing.map(m => m.label).join(', ')}`
        : 'Faltan datos en el formulario de experiencias';
      this.notificationService.info(message);
      setTimeout(() => scrollToFirstInvalid(scope, 'experience'), 0);
      return;
    }
    const experiencePayload = this.buildPayloadExperience();
    const requestPayload: any = {
      client_id: this.userService.clientIdFusion,
      agency_id: this.userService._agencyID,
      agent_id: this.userService._agentID,
      requestType: this.formExperience.get('requestType')?.value ?? null,
      products: {
        experiences: experiencePayload
      }
    };
    console.log('[form-offline] experience payload built:', requestPayload.products.experiences);
    this.openCreatedConfirmationModal(requestPayload);
  }

  onExperienceClear(): void {
  }

  onTransferSubmit(payload: any): void {
    this.formTransferEdited = true;
    if (this.formTransfer.invalid) {
      const scope = (document.querySelector('.form-offline-wrapper') ?? document.body) as HTMLElement;
      const missing = markFormInvalid(this.formTransfer, 'transfer');
      const message = missing.length > 0
        ? `Faltan datos en el traslado: ${missing.map((m: any) => m.label).join(', ')}`
        : 'Faltan datos en el formulario de traslado';
      this.notificationService.info(message);
      setTimeout(() => scrollToFirstInvalid(scope, 'transfer'), 0);
      return;
    }
    const transferPayload = this.buildPayloadTransfer();
    const requestPayload: any = {
      client_id: this.userService.clientIdFusion,
      agency_id: this.userService._agencyID,
      agent_id: this.userService._agentID,
      requestType: this.formTransfer.get('requestType')?.value ?? null,
      products: {
        transfers: transferPayload
      }
    };
    console.log('[form-offline] transfer payload built:', requestPayload.products.transfers);
    this.openCreatedConfirmationModal(requestPayload);
  }

  onTransferClear(): void {
  }

  /**
   * Muestra el `ConfirmationModalComponent` previo al POST con el mensaje
   * "Se creará la solicitud de Cotización. En el plazo máximo de 2 horas gestionamos tu solicitud".
   *
   * - Confirmar dispara `createRequestOffline` y al éxito cierra el formulario.
   *   (Mantenemos el toast `Su solicitud ha sido registrada con éxito...` que tenía
   *   el flujo original al final del POST exitoso.)
   * - Cancelar no hace nada.
   *
   * Reemplaza al `MaterialModalConfirmComponent` ("Crear solicitud") por el
   * modal estándar del proyecto.
   */
  private openCreatedConfirmationModal(payload: any): void {
    const initialState: ModalOptions = {
      initialState: {
        title: '',
        message: 'Se creará la solicitud de Cotización. En el plazo máximo de 2 horas gestionamos tu solicitud',
        confirmText: 'Sí',
        cancelText: 'No',
        showCancelButton: true,
        icon: ''
      }
    };

    const modalOptions = Object.assign({}, initialState);
    const confirmationRef = this.modalService.show(ConfirmationModalComponent, modalOptions);

    confirmationRef.content.confirmResult.subscribe((result: boolean) => {
      if (!result) {
        return;
      }
      this.spinner.show();
      this.formService.createRequestOffline(payload).subscribe({
        next: (res: any) => {
          this.spinner.hide();
          this.notificationService.success('Su solicitud ha sido registrada con éxito. Pronto alguno de nuestros operadores se pondrá en contacto con usted');
          this.afterSuccessfulSubmit();
        },
        error: (error: HttpErrorResponse) => {
          this.notificationService.error('Ha ocurrido un error, vuelva a intentarlo más tarde', 'error: ', error.error);
          this.spinner.hide();
        }
      });
    });
  }

  /**
   * Submit handler for the "Reabrir" (reopen) flow.
   * Sends the request back with status = 1 (Recibida) so it re-enters
   * the operator queue as a fresh request.
   */
  onReopenSubmit(): void {
    const detailId = this.editData?.id;
    if (detailId === null || detailId === undefined) {
      this.notificationService.error('No se pudo identificar la solicitud a reabrir.');
      return;
    }

    const payload = { status: 1 };

    this.spinner.show();
    this.formService.updateRequestOffline(detailId, payload).subscribe({
      next: (res: any) => {
        this.spinner.hide();
        this.notificationService.success('Solicitud reabierta correctamente.');
        // Retornamos `true` para que el padre recargue la lista con el nuevo estado.
        this.closeDialog(true);
        if (!this.isInsideDialog) {
          this.resetAfterSubmit();
          this.submitted.emit();
        }
      },
      error: (err: HttpErrorResponse) => {
        this.spinner.hide();
        this.notificationService.error(
          'No se pudo reabrir la solicitud.',
          err?.error?.message || ''
        );
      }
    });
  }

    buildPayloadHotel(): any {
      const raw = this.formHotel.value;
        // Compute flat room fields from FormArray for backend compatibility
        const rooms: any[] = raw.room || [];
        let adults = 0;
        let childs = 0;
        const allAges: number[] = [];
        rooms.forEach((r: any) => {
          adults += Number(r.qtyAdults) || 0;
          const roomChilds = Number(r.qtyChilds) || 0;
          childs += roomChilds;
          const childsage: any[] = r.childsage || [];
          childsage.forEach((child: any) => {
            const age = Number(child.age);
            if (!isNaN(age) && age >= 0 && age <= 17) {
              allAges.push(age);
            }
          });
        });
        raw.adults = adults;
        raw.childs = childs;
        raw.age_childs = allAges.length > 0 ? allAges.join(', ') : null;
        raw.qty_rooms = rooms.length;

        // Preferencias por habitacion: cada room viaja con su propio set
        // (regimen, categoria, tipo de cama y politica de cancelacion).
        // El indice del array es el de la habitacion, asi que el backend puede
        // cruzar `room[i].preferences` con la tarifa `occupancyRoom` de cada
        // habitacion cotizada.
        const roomPayload = rooms.map((r: any) => {
          const prefs = r?.preferences || {};
          const preferences: any = {};
          if (prefs.meals) {
            preferences.meals = [prefs.meals];
          }
          if (prefs.category) {
            preferences.category = [prefs.category];
          }
          if (prefs.type_bed) {
            preferences.type_bed = [prefs.type_bed];
          }
          if (prefs.cancellationPolicy) {
            preferences.cancellationPolicy = prefs.cancellationPolicy;
          }
          return {
            qtyAdults: Number(r.qtyAdults) || 0,
            qtyChilds: Number(r.qtyChilds) || 0,
            childsage: (r.childsage || []).map((child: any) => ({
              id: child?.id ?? null,
              age: Number(child?.age) || 0
            })),
            preferences
          };
        });
        raw.room = roomPayload;

        // Campos legacy de la raiz (los que hoy lee el backend para filtrar):
        // se calculan como union de las habitaciones.
        const legacyPreferences = this.buildLegacyPreferences(roomPayload);
        raw.meals = legacyPreferences.meals;
        raw.category = legacyPreferences.category;
        raw.type_bed = legacyPreferences.type_bed;
        raw.cancellationPolicy = legacyPreferences.cancellationPolicy;

        // price_night se guarda como string de digitos para poder tipear libremente;
        // lo parseamos a numero antes de mandarlo al backend para preservar el shape original.
        raw.price_night = this.parsePriceNightForBackend();

        // Moneda de la solicitud: la de la agencia (userService.currency.code).
        // Viaja en la raiz del `product` porque el backend la lee desde ahi
        // (OfflineHotelQuoteService::operatorQuote -> $request['currency']) para
        // saber en que moneda estan los importes que carga el operador y con
        // que tipo de cambio se calculan. Sin esto el backend asume USD.
        raw.currency = (this.currencyCode || 'ARS').toUpperCase();

        // Also delete hotelNames array wrapper — backend expects a flat string in hotelsName
        if (Array.isArray(raw.hotelNames) && raw.hotelNames.length > 0) {
          raw.hotelsName = raw.hotelNames[0]?.name ?? null;
        }
        delete raw.hotelNames;

        if (this.formHotel.get('requestType')?.value !== 'quotation') {
          const passenger = this.formHotel.get('passenger')!.value;
          if (passenger.id != null) {
            raw.passenger = {
              id: passenger.id,
              first_name: passenger.first_name,
              last_name: passenger.last_name,
              type: passenger.type
            };
          } else if ((passenger.first_name || '').trim() || (passenger.last_name || '').trim()) {
            raw.passenger = {
              first_name: passenger.first_name,
              last_name: passenger.last_name,
              type: passenger.type
            };
          }
        }

      const cleaned = this.cleanPayload(raw);

      // Valor estimado por noche (costo referencial del hotel segun Zoco).
      // Va despues de cleanPayload porque ese helper filtra los nulls y el
      // campo tiene que viajar siempre (null si el hotel no tiene referencial).
      // El control `estimatedRate` es disabled, asi que no viene en
      // `formHotel.value`: se lee del control. Se manda como numero (el
      // endpoint lo devuelve como string "12.00").
      cleaned.estimated_rate = this.estimatedRateValue();

      return cleaned;
    }

    /**
   * Factory de grupos de traslado para el `usb-transfer-form`.
   *
   * Se pasa como arrow function para no perder el `this` del componente
   * padre cuando el form la invoca.
   */
  readonly createTransferGroupFn = () => this.createTransferGroup();

  /**
   * Los competidores van con el formato que espera el backend:
   * [{ url, price, currency, images: [] }]. Las capturas se cuelgan del
   * primer competidor; si hay imágenes pero ningún enlace, se crea un
   * competidor sin url para no perderlas.
   */
  private buildTransferCompetitors(): any[] {
    const urls = (this.formTransfer.get('competitorUrls') as FormArray)?.value || [];
    const images = (this.formTransfer.get('competitorImages') as FormArray)?.value || [];

    const competitors = urls
      .map((url: any) => (typeof url === 'string' ? url.trim() : ''))
      .filter((url: string) => url !== '')
      .map((url: string, index: number) => ({
        url,
        price: null,
        currency: null,
        images: index === 0 ? images : []
      }));

    if (competitors.length === 0 && images.length > 0) {
      competitors.push({ url: null, price: null, currency: null, images });
    }

    return competitors;
  }

  /**
   * Payload del producto "transfers".
   *
   * Modelo repetible: `transfers` es un array con un objeto por traslado
   * (mismo shape que usaba el modelo anterior de un solo traslado).
   *
   * Para no romper el backoffice actual, los campos del PRIMER traslado
   * también se mandan planos en la raíz del producto (`origin`,
   * `destination`, `pickupDate`, ...), tal como los leía antes. Si el
   * backend pasa a leer el array, estos campos planos se pueden dejar de
   * mandar.
   */
  buildPayloadTransfer(): any {
      // `getRawValue()` (y no `value`) para que también trafficking los
      // controles deshabilitados (modo edición).
      const raw = this.formTransfer.getRawValue();
      const transfersArray = this.formTransfer.get('transfers') as FormArray;
      const transfers = (transfersArray?.getRawValue() ?? [])
        .map((transfer: any) => this.buildTransferProduct(transfer))
        .filter((transfer: any) => transfer !== null);
      const first = transfers[0] ?? {};

      const cleaned: any = {
        // Snake case para matchear el backend (`OfflineRequest::fileId()` lee
        // `detail->product['file_id']`). Antes el payload de transfer no
        // incluía estos campos, así que el backend nunca los recibía.
        file_id: raw.file_id,
        client_id: raw.client?.client_id,
        requestType: raw.requestType,
        // Campos planos del primer traslado (compatibilidad con el backoffice).
        ...first,
        // Modelo repetible: todos los traslados de la solicitud.
        transfers,
        // Vuelos cargados a mano (compartidos por todos los traslados).
        manualFlights: (this.formTransfer.get('manualFlights') as FormArray)?.getRawValue() ?? [],
        comments: raw.comments || '',
        passenger: raw.passenger || {},
        competitors: this.buildTransferCompetitors()
      };
      return this.cleanPayload(cleaned);
    }

    /**
     * Convierte un traslado del FormArray en el objeto que viaja en el
     * payload (mismo shape que usaba el modelo anterior de un solo traslado).
     */
    private buildTransferProduct(transfer: any): any {
      if (!transfer) {
        return null;
      }
      const hasReturn = !!transfer.returnDate;
      return {
        origin: transfer.origin,
        destination: transfer.destination,
        pickupDate: transfer.pickupDate ? this.toDateString(transfer.pickupDate) : null,
        pickupTime: transfer.pickupTime,
        returnDate: transfer.returnDate ? this.toDateString(transfer.returnDate) : null,
        returnTime: transfer.returnTime || null,
        adults: Number(transfer.adults) || 1,
        children: Number(transfer.children) || 0,
        childAges: transfer.childAges || [],
        // Cantidad de vehículos del traslado.
        vehicleCount: Number(transfer.vehicleCount) || 1,
        // Vuelos asociados al traslado (objetos completos, no sólo los ids).
        flights: transfer.flights || [],
        flightIds: transfer.flightIds || [],
        // Campos legacy de la raiz: union de las preferencias de ambos tramos
        // (los que hoy lee el backend para filtrar).
        modality: unionPreference(transfer.preferences?.ida?.modality, transfer.preferences?.vuelta?.modality),
        category: unionPreference(transfer.preferences?.ida?.category, transfer.preferences?.vuelta?.category),
        vehicles: unionPreference(transfer.preferences?.ida?.vehicles, transfer.preferences?.vuelta?.vehicles),
        // Preferencias por tramo (ida / vuelta).
        preferences: buildTransferPreferences(transfer.preferences, hasReturn),
        comments: transfer.comments || ''
      };
    }

    buildPayloadRentACar(): any {
      const raw = this.formRentACar.value;
        if (raw.currency && typeof raw.currency === 'string') {
            raw.currency = raw.currency.toUpperCase();
        }
      return this.cleanPayload(raw);
    }

    buildPayloadExperience(): any {
      const raw = this.formExperience.value;
      const paxId = raw.passenger?.id;
      const pax = this.availablePax.find(p => String(p.idUnique) === String(paxId)) || null;
      const passengerName = (raw.passenger?.first_name || '') + ' ' + (raw.passenger?.last_name || '').trim();
      // children + childAges -> age_childs (string CSV) y childs (count), igual
      // que hotel. El BackOffice (`request-offline-details.component.html:431`)
      // lee `age_childs` snake del JSON del producto.
      const childs = Number(raw.children) || 0;
      const childAges: any[] = raw.childAges || [];
      const validAges = childAges
        .map((age: any) => Number(age))
        .filter((age: number) => !isNaN(age) && age >= 0 && age <= 17);
      // passenger -> mismo shape que hotel: { id, first_name, last_name, type }.
      // `type: 'adult'` por defecto porque experience no distingue adultos/niños
      // en su modelo de pax (sólo adultos pueden ser "pasajeros titulares").
      const passenger: any = pax
        ? { id: pax.idUnique, first_name: raw.passenger?.first_name, last_name: raw.passenger?.last_name, type: 'adult' }
        : (raw.passenger?.first_name || raw.passenger?.last_name
            ? { first_name: raw.passenger?.first_name, last_name: raw.passenger?.last_name, type: 'adult' }
            : null);
      // detail.cancellation (array) -> detail.cancellationPolicy (string escalar),
      // mismo shape que hotel. El BackOffice espera string escalar
      // (`SCALAR_STRING_OVERRIDE_FIELDS` = `'cancellationPolicy'`).
      const details = raw.details || {};
      const cancellationPolicy = Array.isArray(details.cancellation) && details.cancellation.length > 0
        ? details.cancellation[0]
        : null;
      const detail = { ...details, cancellationPolicy };
      delete detail.cancellation;
      const cleaned: any = {
        // Snake case para matchear el backend (`OfflineRequest::fileId()` lee
        // `detail->product['file_id']`). Antes se mandaba `fileId`/`clientId`
        // (camelCase) desde state UI y el backend los ignoraba.
        file_id: raw.file_id,
        client_id: raw.client?.client_id,
        passenger,
        requestType: raw.requestType,
        experienceType: raw.type,
        destination: raw.destination,
        checkIn: raw.checkIn,
        checkOut: raw.checkOut,
        adults: Number(raw.adults) || 0,
        childs,
        age_childs: validAges.length > 0 ? validAges.join(', ') : null,
        detail,
        // searchNotes = "expandir búsqueda" (referencias para ampliar), no es un
        // comentario del agente. Se mantiene fuera de comment_contact.
        expandedNotes: raw.searchNotes || '',
        // comment_contact = bloque "Comentarios u observaciones" del template
        // (mismo label que hotel).
        comment_contact: raw.comments || ''
      };
      return this.cleanPayload(cleaned);
    }

    private cleanPayload(obj: any): any {
      const cleaned: any = {};
      for (const key in obj) {
        const val = obj[key];
        // Filtrar null/undefined
        if (val === null || val === undefined) {
          continue;
        }
        // Filtrar arrays vacíos
        if (Array.isArray(val) && val.length === 0) {
          continue;
        }
        // Filtrar strings vacíos
        if (typeof val === 'string' && val.trim() === '') {
          continue;
        }
        cleaned[key] = val;
      }
      return cleaned;
    }

    /**
     * Convierte un valor de fecha (Date nativo, Moment, o string ISO) a
     * formato `YYYY-MM-DD`. Usado por `onSubmit()` antes de mandar el payload
     * al backend, porque los form-controls pueden entregar cualquiera de
     * esos tipos según qué los populó (datepicker, ngModel, patchValue).
     */
    private toDateString(value: any): string {
      if (!value) return null;
      // Date nativo
      if (value instanceof Date) {
        const y = value.getFullYear();
        const m = String(value.getMonth() + 1).padStart(2, '0');
        const d = String(value.getDate()).padStart(2, '0');
        return `${y}-${m}-${d}`;
      }
      // Moment o dayjs (ambos exponen `.format` y `.toDate()`)
      if (typeof value.format === 'function') {
        return value.format('YYYY-MM-DD');
      }
      // String o número: caemos a moment como fallback (mantiene
      // compatibilidad con el código viejo que recibía ISO strings).
      return moment(value).format('YYYY-MM-DD');
    }

  close(): void {
    this.closed.emit();
    this.closeDialog();
  }

  /**
   * `true` cuando el componente está montado dentro de un MatDialog real.
   *
   * En la página `/offline-quote` no hay dialog: se inyecta un stub
   * (`MatDialogRef` sin `close`), por lo que este getter devuelve `false` y
   * permite diferenciar "estoy en un modal" de "estoy en una página".
   */
  private get isInsideDialog(): boolean {
    const ref: any = this.dialogRef;
    return !!(ref && typeof ref.close === 'function');
  }

  /**
   * Se ejecuta luego de que la solicitud se envió con éxito.
   *
   * - En el modal (dialog): se cierra, como siempre.
   * - En la página (`/offline-quote`): NO se cierra ni se navega. Se resetea
   *   el formulario para que el agente pueda cargar otra cotización y se
   *   emite `submitted` para que el padre quede enterado.
   */
  private afterSuccessfulSubmit(): void {
    if (this.isInsideDialog) {
      this.close();
      return;
    }
    this.resetAfterSubmit();
    this.submitted.emit();
  }

  /**
   * Resetea el formulario a su estado inicial después de un envío exitoso.
   *
   * OJO: es un RESET, no un "clean"/limpieza. No se destruye el componente ni
   * se pierde el contexto del file y del cliente ya seleccionados: sólo se
   * vacía la cotización (destino, fechas, hotel, preferencias, precios,
   * comentarios) y se deja el formulario listo para cargar otra.
   *
   * Los FormGroups se resetean "en el lugar" (no se recrean) para no romper
   * las suscripciones a `valueChanges` de los autocompletes y de los
   * componentes hijos (`usb-transfer-form`, `usb-experience-form`).
   */
  resetAfterSubmit(): void {
    const fileId = this.selectedFileId;
    const fileName = this.formHotel?.get('fileName')?.value ?? null;
    const clientValue = this.formHotel?.get('client')?.value ?? null;

    // ---------------- HOTEL ----------------
    this.formHotel.get('destination')?.setValue(null);
    this.formHotel.get('arrivalDepartureDate')?.setValue(null);
    this.formHotel.get('price_night')?.setValue(null);
    this.formHotel.get('estimatedRate')?.setValue(null);
    this.formHotel.get('nationality')?.setValue(null);
    this.formHotel.get('comment_contact')?.setValue(null);
    this.formHotel.get('roomConfiguration')?.setValue(null);
    this.formHotel.get('cancellationPolicy')?.setValue(null);
    this.formHotel.get('requestType')?.setValue('quotation');
    this.formHotel.get('passenger')?.reset({ id: null, first_name: '', last_name: '', type: '' });

    // Nombres de hotel: queda una sola fila vacía. NO recreamos el control
    // (conservamos la instancia) para no perder la suscripción del
    // autocomplete que dispara la búsqueda de hoteles.
    const hotelNames = this.formHotel.get('hotelNames') as FormArray;
    while (hotelNames.length > 1) {
      hotelNames.removeAt(hotelNames.length - 1);
    }
    hotelNames.at(0)?.get('name')?.setValue(null);

    // Habitaciones: una sola, la default (1 adulto, sin preferencias).
    const roomArray = this.formHotel.get('room') as FormArray;
    while (roomArray.length > 0) {
      roomArray.removeAt(roomArray.length - 1);
    }
    this.addInitialRoom();

    // ---------------- TRASLADO ----------------
    this.formTransfer.reset({
      requestType: 'quotation',
      competitorUrls: [''],
      competitorImages: [],
      comments: ''
    });
    // `FormArray.reset()` NO cambia el largo del array: deja los controles
    // que había con valor null. Por eso lo vaciamos a mano (mismo criterio que
    // usa el `usb-transfer-form` en su acción de limpiar).
    // IMPORTANTE: conservamos el primer control en vez de recrearlo, porque
    // el `usb-transfer-form` le setea el validator de URL por control.
    const transfers = this.formTransfer.get('transfers') as FormArray;
    transfers.clear();
    transfers.push(this.createTransferGroup());
    // Los vuelos cargados a mano también se borran.
    const manualFlights = this.formTransfer.get('manualFlights') as FormArray;
    if (manualFlights) {
      manualFlights.clear();
    }
    const competitorUrls = this.formTransfer.get('competitorUrls') as FormArray;
    while (competitorUrls.length > 1) {
      competitorUrls.removeAt(competitorUrls.length - 1);
    }
    competitorUrls.at(0)?.setValue('');
    const competitorImages = this.formTransfer.get('competitorImages') as FormArray;
    competitorImages.clear();

    // ---------------- EXPERIENCIAS ----------------
    this.formExperience.reset({
      destination: '', checkIn: '', checkOut: '',
      adults: 2, children: 0, childAges: [],
      budget: '', nationality: '',
      type: 'city', details: {},
      cancellation: [], expanded: false,
      searchNotes: '', comments: '',
      requestType: 'quotation',
      passenger: { id: '', first_name: '', last_name: '' }
    });
    // Igual que en el traslado: el `reset()` del FormArray no vacía el array.
    const experienceChildAges = this.formExperience.get('childAges') as FormArray;
    experienceChildAges.clear();

    // ---------------- RENT A CAR ----------------
    this.formRentACar.reset();

    // Estado de la UI: volvemos a la primera tab y desarmamos lo que quedó
    // expanded (preferencias, búsqueda ampliada, autocompletado de hotel).
    this.tab = 'hotel';
    this.activeRoomTab = 0;
    this.isCollapsed = false;
    this.expandSearchSection = false;
    this.hotelSuggestSearchInput = '';
    this.hotelSuggestResults = [];
    this.hotelSuggestError = null;
    this.loadingHotelsByCity = false;
    this.selectedDestinationIata = null;
    this.startDate = null;
    this.endDate = null;
    this.dateRange = { start: null, end: null };
    this.selectNationalityName = '';
    this.hasReferentialCost = false;
    this.loadingReferentialCost = false;
    this.latestReferentialHotelId = null;

    // Conservamos el contexto del file y del cliente.
    if (fileId != null) {
      this.formHotel.patchValue({ file_id: fileId, fileName: fileName, client: clientValue });
      this.formTransfer.patchValue({ file_id: fileId, fileName: fileName, client: clientValue });
      this.formExperience.patchValue({ file_id: fileId, fileName: fileName, client: clientValue });
    }

    // Los flags de "editado" se limpian DESPUÉS del patch: el `valueChanges`
    // de los forms los vuelve a poner en `true` al patchear el file. Así el
    // próximo envío sólo manda el producto que el usuario complete de nuevo.
    this.formHotelEdited = false;
    this.formTransferEdited = false;
    this.formRentACarEdited = false;
    this.formExperienceEdited = false;
  }

  /**
   * Cierra el MatDialog SOLO si el componente se está mostrando dentro de uno.
   * Cuando se renderiza como página (`/offline-quote`) no hay dialogRef real,
   * y el flujo de cierre lo maneja el componente padre escuchando `closed`.
   */
  private closeDialog(result?: any): void {
    const ref: any = this.dialogRef;
    if (ref && typeof ref.close === 'function') {
      ref.close(result);
    }
  }

  // =============================================
  // SELECTOR DE FILES EXISTENTES (ITINERARIES)
  // =============================================

  /**
   * Carga la lista de itineraries del agente para el selector de files.
   * Si `searchTerm` viene vacío, trae los más recientes (comportamiento original).
   * Si viene con texto, filtra por título del itinerary o nombre/apellido de cliente.
   */
  loadExistingFiles(searchTerm: string = ''): void {
    const agentId = this.userService._agentID;
    if (!agentId) {
      return;
    }
    this.loadingFiles = true;
    this.formService.getItinerariesForAgent(agentId, 1, 100, searchTerm).subscribe({
      next: (res) => {
        const results: any[] = Array.isArray(res) ? res : (res?.data || []);
        // Si el usuario está buscando y no hubo resultados, mostramos un mensaje
        // en el dropdown en vez de cerrarlo vacío.
        if (searchTerm.trim() !== '' && results.length === 0) {
          this.existingFiles = [{
            __noResults: true,
            __label: 'No se encontraron files con ese criterio.'
          }];
        } else {
          this.existingFiles = results;
        }
        this.loadingFiles = false;
        // La lista ya está disponible: recién ahora se puede resolver el file
        // preseleccionado (label real + clientes) que venía del itinerary activo.
        this.applyPendingPrefillFile();
      },
      error: () => {
        this.existingFiles = [];
        this.loadingFiles = false;
        // Aunque la lista falle, el file del itinerary activo se puede
        // preseleccionar con el metadata que pasó el caller.
        this.applyPendingPrefillFile();
      }
    });
  }

  /**
   * Preselecciona el file del itinerary activo (prefill del header).
   *
   * Se invoca cuando la lista de files terminó de cargar. La fuente
   * autoritativa es `existingFiles`: ahí viene el label real (title/nombre) y
   * los clientes del file. Si el file no está en la lista (el endpoint devuelve
   * sólo los últimos N itineraries), se cae al metadata que pasó el caller
   * (`data.prefillFile`) para no dejar el selector vacío.
   *
   * El flujo es idéntico al de una selección manual: se setea `selectedFile`,
   * `selectedFileId`, el control `file_id` y el control `fileName` (con el
   * label legible, que es lo que viaja en el payload) y se autocompleta el
   * cliente si el file tiene exactamente uno.
   */
  private applyPendingPrefillFile(): void {
    const prefillFile = this.data?.prefillFile ?? this.prefillFile;
    if (!prefillFile?.id || this.pendingPrefillFileId == null) {
      return;
    }
    if (this.edit) {
      this.pendingPrefillFileId = null;
      return;
    }
    // Si el usuario ya eligió algo en el selector, no pisamos su selección.
    if (this.selectedFileId != null) {
      this.pendingPrefillFileId = null;
      return;
    }

    const fileId = this.pendingPrefillFileId;
    this.pendingPrefillFileId = null;

    const fileFromList = this.existingFiles.find((f: any) => Number(f?.id) === Number(fileId));
    const file = fileFromList ?? {
      id: fileId,
      name: prefillFile.name ?? prefillFile.title ?? null,
      title: prefillFile.title ?? prefillFile.name ?? null,
      clients: this.normalizeClients(prefillFile.clients),
      __synthetic: true,
    };

    this.selectedFile = file;
    this.selectedFileId = fileId;
    this.fileAutocompleteModel = file;

    // Mismo camino que la selección manual: setea file_id + fileName en el form.
    this.onExistingFileSelected(fileId, file);

    // Si el file tiene exactamente un cliente, se preselecciona.
    const clients = this.normalizeClients(file.clients);
    if (clients.length === 1) {
      this.selectedClientId = clients[0].id;
      this.onClientSelectedFromFile(clients[0].id);
    }
  }

  /**
   * Normaliza `clients` a un array. El itinerary activo lo expone como objeto
   * único, mientras que el endpoint de itineraries lo devuelve como array.
   */
  private normalizeClients(clients: any): any[] {
    if (Array.isArray(clients)) {
      return clients.filter((c: any) => !!c);
    }
    if (clients && typeof clients === 'object') {
      return [clients];
    }
    return [];
  }

  loadPaxForFile(fileId: number | string): void {
    this.loadingPax = true;
    this.availablePax = [];
    this.restService.doGet('app', 'itineraries/' + fileId).subscribe({
      next: (r: any) => {
        this.availablePax = r?.data?.paxList ?? [];
        this.loadingPax = false;
      },
      error: () => {
        this.availablePax = [];
        this.loadingPax = false;
      }
    });
  }

  /**
   * Carga los vuelos del file seleccionado para el bloque "Vuelos asociados"
   * del tab de traslados.
   *
   * El endpoint `itineraries/{id}` devuelve el itinerary con `flights`, donde
   * cada vuelo tiene los dos tramos (`in` / `out`). El form de traslados los
   * convierte a una entrada por tramo (Lovable: "Llegada" / "Salida").
   */
  loadFlightsForFile(fileId: number | string | null): void {
    if (!fileId) {
      this.fileFlights = [];
      return;
    }
    this.loadingFlights = true;
    this.restService.doGet('app', 'itineraries/' + fileId).subscribe({
      next: (r: any) => {
        this.fileFlights = Array.isArray(r?.data?.flights) ? r.data.flights : [];
        this.loadingFlights = false;
      },
      error: () => {
        this.fileFlights = [];
        this.loadingFlights = false;
      }
    });
  }

  onPassengerIdChange(paxId: number | null): void {
    if (paxId == null) {
      this.formHotel.get('passenger')!.reset({ id: null, first_name: '', last_name: '', type: '' });
      // Limpiamos también el client_id del sub-form cliente. Sin selector visible,
      // el cliente se resuelve desde el pasajero: si no hay pasajero, no hay cliente.
      this.formHotel.get('client.client_id')?.setValue(null);
      this.selectedClientId = null;
      return;
    }
    const p = this.availablePax.find(x => x.idUnique === paxId);
    if (!p) {
      return;
    }
    this.formHotel.get('passenger')!.patchValue({
      id: p.idUnique,
      first_name: p.first_name,
      last_name: p.last_name,
      type: p.type
    });
    // Auto-resolver el cliente desde el pasajero seleccionado.
    // El objeto pax trae clientId (id del cliente asociado al pasajero en el backend).
    const resolvedClientId = (p as any).clientId ?? (p as any).clientSelected ?? null;
    if (resolvedClientId != null) {
      this.selectedClientId = resolvedClientId;
      this.formHotel.get('client.client_id')?.setValue(resolvedClientId);
    }
  }

  /**
   * Handler del input de búsqueda de files con debounce de 250ms
   * para no disparar una request por cada tecla.
   */
  onFileSearchInput(value: string): void {
    this.fileSearchText = value;
    if (this.fileSearchDebounce) {
      clearTimeout(this.fileSearchDebounce);
    }
    this.fileSearchDebounce = setTimeout(() => {
      this.loadExistingFiles(value);
    }, 250);
  }

  /**
   * Handler del mat-autocomplete cuando el usuario elige un file del dropdown.
   * `value` es el objeto completo del file (porque [value]="f" en el mat-option).
   */
  onFileSelectedFromAutocomplete(value: any): void {
    if (!value || value.__noResults) {
      return;
    }
    // Mientras el usuario tipea en el input, el autocomplete emite el string
    // crudo (no un file). No es una selección: si lo tomáramos, el `selectedFile`
    // quedaba como texto y se pisaba el file preseleccionado (y el `file_id`
    // se limpiaba). La búsqueda del texto se maneja en `onFileSearchInput`.
    if (typeof value === 'string' || typeof value === 'number') {
      return;
    }
    this.selectedFile = value;
    this.selectedFileId = value.id;
    this.fileAutocompleteModel = value;
    // Reutilizamos el handler existente para mantener compatibilidad con el resto del form.
    this.onExistingFileSelected(value.id, value);
  }

  /**
   * Handler del ngModel del input de búsqueda. Detecta cuando el usuario
   * borra el contenido manualmente y resetea la selección.
   */
  onFileAutocompleteModelChange(value: any): void {
    this.fileAutocompleteModel = value;
    if (!value) {
      this.clearSelectedFile();
    }
  }

  /**
   * Limpia el file seleccionado y resetea el input de búsqueda.
   */
  clearSelectedFile(): void {
    this.selectedFile = null;
    this.selectedFileId = null;
    this.fileSearchText = '';
    this.fileAutocompleteModel = null;
    this.selectedClientId = null;
    this.existingFiles = [];
  }

  onPaxChange(paxId: number | null): void {
    if (paxId == null) {
      this.formExperience.get('passenger')!.reset({ id: null, first_name: '', last_name: '' });
      this.availablePax = [];
      return;
    }
    const p = this.availablePax.find(x => x.idUnique === paxId);
    if (!p) {
      return;
    }
    this.formExperience.get('passenger')!.patchValue({
      id: p.idUnique,
      first_name: p.first_name,
      last_name: p.last_name
    });
  }

  onRequestTypeChange(value: any): void {
    this.formExperience.get('requestType')!.setValue(value);
  }

  onPassengerFirstNameChange(value: string): void {
    this.formExperience.get('passenger.first_name')!.setValue(value);
  }

  onPassengerLastNameChange(value: string): void {
    this.formExperience.get('passenger.last_name')!.setValue(value);
  }

  onClientFirstNameChange(value: string): void {
    this.formExperience.get('client.first_name')!.setValue(value);
  }

  onClientLastNameChange(value: string): void {
    this.formExperience.get('client.last_name')!.setValue(value);
  }

  onClientEmailChange(value: string): void {
    this.formExperience.get('client.email')!.setValue(value);
  }

  onClientPhoneChange(value: string): void {
    this.formExperience.get('client.phone')!.setValue(value);
  }

  onFileChange(value: any): void {
    this.onFileSelectedFromAutocomplete(value);
  }

  onClientChange(clientId: any): void {
    this.onClientSelectedFromFile(clientId);
  }

  onNewFilePassengerInput(value: string): void {
    this.newFilePassenger = value;
  }

  onNewFilePhoneInput(value: string): void {
    this.newFilePhone = value;
  }

  onNewFileEmailInput(value: string): void {
    this.newFileEmail = value;
  }

  onPhoneCodeInput(value: string): void {
    this.phoneCodeSelected = value;
  }

  onCreateNewClient(payload: { first_name: string; last_name: string; email: string; phone_code: string; phone: string }): void {
    const client = {
      ...payload,
      id: null,
      title: null,
      phone_code_number: payload.phone_code
    };
    this.onClientSelected(client);
    this.cancelNewClient();
  }

  /**
   * Genera un label legible para mostrar en el <option> del select.
   * Prioriza f.name o f.title. Si no existe, muestra "File N° {id}".
   * Si tiene cliente, agrega el nombre al label.
   */
  getFileLabel(f: any): string {
    // Sin file seleccionado no hay label que mostrar. Sin esta guarda, el template
    // interpolaba `File N° undefined` porque f?.id resolvía a undefined.
    if (!f) {
      return '';
    }
    const id = f?.id;
    const name = f?.name || f?.title;
    // clients puede ser un objeto único o un array
    let firstClient: any = null;
    if (Array.isArray(f?.clients) && f.clients.length > 0) {
      firstClient = f.clients[0];
    } else if (f?.clients && typeof f?.clients === 'object') {
      firstClient = f.clients;
    }
    const clientName = firstClient
      ? `${firstClient.first_name || ''} ${firstClient.last_name || ''}`.trim()
      : '';

    let label = name ? `${name} (#${id})` : `File N° ${id}`;
    if (clientName) {
      label += ` — ${clientName}`;
    }
    return label;
  }

  /**
   * Se ejecuta cuando el usuario selecciona un file del select.
   * Autocompleta el campo fileName y el sub-form del cliente.
   *
   * @param fileId Id del file.
   * @param knownFile File ya resuelto (opcional). Si se pasa, se usa ese
   *        objeto en lugar de buscarlo en `existingFiles` — es el caso del
   *        prefill, donde el file puede no estar en la lista cargada.
   */
  onExistingFileSelected(fileId: number | null, knownFile?: any): void {
    if (fileId == null) {
      this.selectedFileId = null;
      this.selectedClientId = null;
      this.formHotel.get('file_id')?.setValue(null);
      return;
    }

    const file = knownFile ?? this.existingFiles.find((f) => Number(f?.id) === Number(fileId));

    this.selectedFileId = fileId;
    // Resetear el cliente seleccionado: los clientes del file nuevo son distintos.
    this.selectedClientId = null;

    // Setear file_id en el form para que viaje en el payload.
    // Si el file no está en `existingFiles` (caso típico del prefill del
    // sidebar, donde el id viene del itinerary activo), igual lo seteamos
    // con el id recibido — el backend valida que exista, no nosotros.
    this.formHotel.get('file_id')?.setValue(fileId);
    this.formExperience.get('file_id')?.setValue(fileId);
    // El traslado usa el mismo file que el resto de la solicitud: sin esto,
    // el payload del traslado Viajava sin file_id (y los vuelos asociados no
    // se podían cargar).
    this.formTransfer.get('file_id')?.setValue(fileId);

    // Setear el fileName con el label legible (mismo valor que envía la
    // selección manual). Si no hay metadata del file, usamos el prefillFile.name
    // que llega del caller.
    if (file) {
      const label = this.getFileLabel(file);
      this.formHotel.get('fileName')?.setValue(label);
      this.formExperience.get('fileName')?.setValue(label);
    } else if ((this.data?.prefillFile ?? this.prefillFile)?.id === fileId) {
      const fallbackName = (this.data?.prefillFile ?? this.prefillFile)?.name ?? (this.data?.prefillFile ?? this.prefillFile)?.title ?? null;
      this.formHotel.get('fileName')?.setValue(fallbackName);
      this.formExperience.get('fileName')?.setValue(fallbackName);
    }

    // Sin metadata suficiente, no podemos seguir con el cliente.
    if (!file) {
      return;
    }

    // Autocompletar el sub-form del cliente (solo en modo creación)
    if (this.edit) {
      return;
    }

    // clients puede ser objeto único o array
    const clients = this.normalizeClients(file.clients);
    const firstClient = clients.length > 0 ? clients[0] : null;

    if (!firstClient) {
      this.notificationService.info('Este file no tiene clientes asociados');
      return;
    }

    const clientGroup = this.formHotel.get('client') as FormGroup;
    clientGroup.patchValue({
      first_name: firstClient.first_name || null,
      last_name: firstClient.last_name || null,
      email: firstClient.email || null,
      phone: firstClient.phone || null,
      phone_code: firstClient.phone_code || firstClient.phone_code_number || null
    });

    this.formHotelEdited = true;
  }

  /**
   * Cuando el usuario tipea en el input fileName, limpiar la selección
   * del select para evitar conflicto entre typed value y selected file.
   */
  onFileNameInput(): void {
    if (this.selectedFileId != null) {
      this.selectedFileId = null;
      this.formHotel.get('file_id')?.setValue(null);
    }
  }

  /**
   * Abre el input para tipear un nombre de file nuevo. Limpia la selección
   * del select de files para que no haya conflicto.
   */
  openNewFileNameInput(): void {
    this.showNewFileNameInput = true;
    this.selectedFileId = null;
    this.selectedClientId = null;
    this.formHotel.get('fileName')?.setValue(null);
    this.formHotel.get('file_id')?.setValue(null);
    this.formExperience.get('fileName')?.setValue(null);
    this.formExperience.get('file_id')?.setValue(null);
  }

  /**
   * Cierra el input de nombre nuevo y vuelve al modo "seleccionar file existente".
   * Limpia el valor del input `fileName` para que no quede colgado.
   */
  cancelNewFileName(): void {
    this.showNewFileNameInput = false;
    this.formHotel.get('fileName')?.setValue(null);
    this.formHotel.get('file_id')?.setValue(null);
  }

  /**
   * Abre los inputs para tipear los datos de un cliente nuevo.
   * Limpia la selección del select de cliente y resetea el sub-form.
   */
  openNewClientInput(): void {
    this.showNewClientInput = true;
    this.selectedClientId = null;
    const clientGroup = this.formHotel.get('client') as FormGroup;
    clientGroup.patchValue({
      client_id: null,
      first_name: null,
      last_name: null,
      email: null,
      phone: null,
      phone_code: null
    });
  }

  /**
   * Cierra los inputs del nuevo cliente y vuelve al modo "seleccionar cliente del file".
   * Limpia el sub-form del cliente para que no quede colgado.
   */
  cancelNewClient(): void {
    this.showNewClientInput = false;
    const clientGroup = this.formHotel.get('client') as FormGroup;
    clientGroup.patchValue({
      client_id: null,
      first_name: null,
      last_name: null,
      email: null,
      phone: null,
      phone_code: null
    });
  }

  /**
   * Devuelve el array de clientes del file actualmente seleccionado.
   * Normaliza el caso en que `clients` sea objeto único o array.
   * Devuelve [] si no hay file seleccionado o si el file no tiene clientes.
   */
  getClientsForSelectedFile(): any[] {
    if (this.selectedFileId == null) {
      return [];
    }
    // Fallback 1: archivo sintético (patchFormHotel en edit mode usa un objeto
    // inline que no está en existingFiles; pero sus clientes pueden venir del
    // propio editData).
    if (this.selectedFile && this.selectedFile.__synthetic) {
      if (Array.isArray(this.selectedFile.clients)) {
        return this.selectedFile.clients;
      }
      if (this.selectedFile.clients && typeof this.selectedFile.clients === 'object') {
        return [this.selectedFile.clients];
      }
      return [];
    }
    const file = this.existingFiles.find((f) => f.id === this.selectedFileId);
    if (!file) {
      return [];
    }
    if (Array.isArray(file.clients)) {
      return file.clients;
    }
    if (file.clients && typeof file.clients === 'object') {
      return [file.clients];
    }
    return [];
  }

  /**
   * Label legible para un cliente en el select. Prioriza email si no hay nombre.
   */
  getClientLabel(c: any): string {
    if (!c) {
      return '';
    }
    const name = `${c.first_name || ''} ${c.last_name || ''}`.trim();
    return name || c.email || `Cliente #${c.id}`;
  }

  /**
   * Cuando el usuario elige un cliente del select, autocompleta el sub-form.
   * En modo edit no hace nada (toda la sección es read-only).
   */
  onClientSelectedFromFile(clientId: number | string | null): void {
    if (clientId == null) {
      this.selectedClientId = null;
      return;
    }
    if (this.edit) {
      return;
    }

    this.selectedClientId = clientId;
    const clients = this.getClientsForSelectedFile();
    const client = clients.find((c) => c.id === clientId);
    if (!client) {
      return;
    }

    const clientGroup = this.formHotel.get('client') as FormGroup;
    clientGroup.patchValue({
      client_id: client.id || null,
      first_name: client.first_name || null,
      last_name: client.last_name || null,
      email: client.email || null,
      phone: client.phone || null,
      phone_code: client.phone_code || client.phone_code_number || null
    });

    const expClientGroup = this.formExperience.get('client') as FormGroup;
    if (expClientGroup) {
      expClientGroup.patchValue({
        client_id: client.id || null,
        first_name: client.first_name || null,
        last_name: client.last_name || null,
        email: client.email || null,
        phone: client.phone || null,
        phone_code: client.phone_code || client.phone_code_number || null
      });
    }

    this.formHotelEdited = true;
  }

/**
 * Abre y posiciona el popup del daterangepicker. Mismo patrón que
 * hotels.component.ts:openDatePickerSimple — después de open() atachamos
 * el DateRangePickerService al popup para que el tooltip "X días /
 * X noches" funcione en cada hover de celda.
 *
 * Pasamos el contenedor del picker como scope al service para que la
 * búsqueda del .md-drppicker se haga DENTRO de este componente. Si
 * hubiera otro picker abierto en la página (ej: hotels detrás del
 * MatDialog), un querySelector global agarraría el popup equivocado.
 */
openDatePickerSimple(): void {
  if (this.picker) {
    this.picker.open();
    // Pasamos el contenedor padre del input del directive como scope al
    // service. El popup `.md-drppicker` se monta como HERMANO siguiente
    // del <input> (no como hijo — la directiva usa viewContainerRef para
    // crear el componente librería justo después del input host). Por eso
    // tenemos que buscar dentro del parentElement del input, no del input
    // mismo. Si pasáramos el input, document.querySelector('.md-drppicker')
    // relativo a él devolvería null.
    //
    // pickerContainer y elementRef no están en los typings de TS de la
    // directiva, pero sí existen en el bundle JS. Usamos (this.picker as
    // any) para bypassear el chequeo de TS en runtime.
    const inputEl = (this.picker as any)?.elementRef?.nativeElement
      ?? (this.picker as any)?.picker?.pickerContainer?.nativeElement?.parentElement;
    const hostEl = inputEl?.parentElement ?? inputEl;
    this.calendarSyncOffline.attachWhenReady(hostEl);
  }
}

  /** Texto visible del input que muestra "DD/MM/YYYY - DD/MM/YYYY". */
  get dateRangeLabel(): string {
    const start = this.dateRange?.start;
    const end = this.dateRange?.end;
    if (!start || !end) {
      return '';
    }
    return `${dayjs(start).format('DD/MM/YYYY')} - ${dayjs(end).format('DD/MM/YYYY')}`;
  }

    /**
     * Handler del start del daterangepicker.
     * Mismo patrón que hotels.component.ts:999 — guardamos el evento
     * completo y notificamos al service para que el tooltip "X días /
     * X noches" muestre la cuenta desde esta fecha de inicio.
     */
    startDateClicked($event: any): void {
      this.endDate = null;
      this.startDate = $event;
      this.onDateRangeChangeOffline();
    }

    /**
     * Valida y procesa la fecha de fin seleccionada en relación con la
     * fecha de inicio. Mismo patrón que hotels.component.ts:1034.
     */
    endDateClicked($event: any): void {
      const selectedStartDate = dayjs(this.startDate.startDate.$d).startOf('day');
      const selectedEndDate = dayjs($event.endDate.$d).startOf('day');

      this.endDate = $event;

      // Validar que la fecha de fin sea válida, igual o anterior a la fecha de inicio
      if (!selectedEndDate.isValid() || selectedEndDate.isSame(selectedStartDate) || selectedEndDate.isBefore(selectedStartDate)) {
        this.notificationService.warning('Debe elegir mínimo un día de diferencia con el día de inicio');

        this.formHotel.get('arrivalDepartureDate')?.setValue(null);

        setTimeout(() => {
          this.picker.clear();
          this.picker.open();
        }, 100);
      } else {
        this.onDateRangeChangeOffline();
        this.dateRange = { start: selectedStartDate, end: selectedEndDate };
        // Sincronizamos explícitamente el FormControl. El template usa
        // `[(ngModel)]="dateRange"` pero Angular no garantiza el orden de
        // propagación con `formControlName` en el mismo input; si no
        // patcheamos, `arrivalDepartureDate.value` puede quedar desfasado
        // y `formHotel.valid` falla por `required` aunque el usuario haya
        // elegido fechas válidas.
        this.formHotel.get('arrivalDepartureDate')?.setValue({
          start: selectedStartDate,
          end: selectedEndDate
        });
      }
    }

    /**
     * Maneja los cambios de rango del daterangepicker y los propaga al
     * DateRangePickerService para que el tooltip muestre el conteo de
     * noches cuando se está eligiendo el rango. Mismo patrón que
     * hotels.component.ts:onDateRangeChange.
     */
    onDateRangeChangeOffline(): void {
      if (this.startDate && !this.endDate) {
        // Hay start pero no end: el usuario está eligiendo el rango.
        // El service necesita el start para calcular noches en el hover.
        this.calendarSyncOffline.setStartDate(
          this.startDate ? this.startDate : this.dateRange.start
        );
      }
      if (this.startDate && this.endDate) {
        // Rango completo: limpiamos el startDate del service para que
        // la próxima apertura del picker arranque limpia.
        this.calendarSyncOffline.clearStartDate();
      }
    }

  // =============================================
  // HELPERS PARA ROOMS/PASSENGERS MODAL
  // Adaptados de hotels.component.ts para form-offline
  // =============================================

  formRoom(form: FormGroup, key: string): any[] {
    return (<FormArray>form.get(key)).controls;
  }

  hasChildAgeError(room: FormGroup, key: string): boolean {
    const ageArray = room.get(key) as FormArray;
    return ageArray.controls.some(ageControl => {
      const control = ageControl.get('age');
      return control?.errors &&
        (control.hasError('min') ||
          control.hasError('max') ||
          control.hasError('required'));
    });
  }

  /**
   * Crea el grupo de una habitacion del FormArray `room`.
   *
   * Cada habitacion tiene su propio sub-grupo `preferences` (regimen, categoria
   * de habitacion, tipo de cama y politica de cancelacion). Antes estas
   * preferencias vivian en la raiz del form y se aplicaban a todas las
   * habitaciones; ahora son por habitacion (Block 3 con tabs).
   *
   * En el payload los tres primeros viajan como array y la politica como
   * escalar, igual que los campos legacy de la raiz del producto.
   */
  private createRoomGroup(
    qtyAdults: number,
    qtyChilds: number,
    childsage: FormArray,
    preferences?: { meals?: string | null; category?: string | null; type_bed?: string | null; cancellationPolicy?: string | null }
  ): FormGroup {
    return this.formBuilder.group({
      qtyAdults: [qtyAdults, [Validators.required, Validators.min(1), Validators.max(10)]],
      qtyChilds: [qtyChilds],
      childsage: childsage,
      preferences: this.formBuilder.group({
        meals: new FormControl(preferences?.meals ?? null),
        category: new FormControl(preferences?.category ?? null),
        type_bed: new FormControl(preferences?.type_bed ?? null),
        cancellationPolicy: new FormControl(preferences?.cancellationPolicy ?? null)
      })
    });
  }

  /**
   * Preferencias de la habitacion `index`, como objeto plano. Se usa para heredar
   * las de la ultima habitacion al agregar una nueva.
   */
  private roomPreferencesValue(index: number): { meals: any; category: any; type_bed: any; cancellationPolicy: any } {
    const roomArray = this.formHotel?.get('room') as FormArray | undefined;
    const room = roomArray?.at(index) as FormGroup | undefined;
    const prefs = room?.get('preferences')?.value || {};
    return {
      meals: prefs.meals ?? null,
      category: prefs.category ?? null,
      type_bed: prefs.type_bed ?? null,
      cancellationPolicy: prefs.cancellationPolicy ?? null
    };
  }

  /**
   * Normaliza una preferencia que puede venir como array (formato del payload)
   * o como escalar, y devuelve el array de valores.
   */
  private preferenceList(value: any): string[] {
    if (value === null || value === undefined || value === '') {
      return [];
    }
    const list = Array.isArray(value) ? value : [value];
    return list.filter(v => v !== null && v !== undefined && v !== '').map(v => String(v));
  }

  /**
   * Primer valor de una preferencia que puede venir como array o como escalar.
   */
  private firstPreference(value: any): string | null {
    const list = this.preferenceList(value);
    return list.length > 0 ? list[0] : null;
  }

  /**
   * Etiqueta de la tab de preferencias de la habitacion `index`.
   * Ej: "Habitación 1: Doble Estándar" (ocupación + categoría elegida).
   */
  roomTabLabel(index: number): string {
    const roomArray = this.formHotel?.get('room') as FormArray | undefined;
    const room = roomArray?.at(index) as FormGroup | undefined;
    const label = `Habitación ${index + 1}`;
    if (!room) {
      return label;
    }

    const pax = (Number(room.get('qtyAdults')?.value) || 0) + (Number(room.get('qtyChilds')?.value) || 0);
    let occupancy = '';
    if (pax === 1) {
      occupancy = 'Simple';
    } else if (pax === 2) {
      occupancy = 'Doble';
    } else if (pax === 3) {
      occupancy = 'Triple';
    } else if (pax > 3) {
      occupancy = 'Cuádruple';
    }

    const category = room.get('preferences')?.get('category')?.value;
    const categoryLabel = this.roomCategoryLabel(category);

    return [label, occupancy, categoryLabel].filter(part => !!part).join(': ');
  }

  /**
   * Cantidad de preferencias cargadas en la habitacion `index`.
   *
   * Una preferencia cuenta como cargada cuando su control tiene un valor real
   * (`null`, `undefined` y `''` se consideran vacios: el radio de politica de
   * cancelacion usa `''` para la opcion "sin politica").
   */
  roomPreferencesCount(index: number): number {
    const roomArray = this.formHotel?.get('room') as FormArray | undefined;
    const room = roomArray?.at(index) as FormGroup | undefined;
    const prefs = room?.get('preferences')?.value;
    return countRoomPreferences(prefs);
  }

  /**
   * Total de preferencias que se pueden cargar por habitacion.
   */
  readonly roomPreferencesTotal = ROOM_PREFERENCES_TOTAL;

  /**
   * La habitacion `index` ya tiene al menos una preferencia cargada.
   */
  roomHasPreferences(index: number): boolean {
    const roomArray = this.formHotel?.get('room') as FormArray | undefined;
    const room = roomArray?.at(index) as FormGroup | undefined;
    const prefs = room?.get('preferences')?.value;
    return hasRoomPreferences(prefs);
  }

  /**
   * Texto accesible del estado de preferencias de la habitacion `index`.
   */
  roomPreferencesStatusLabel(index: number): string {
    return roomPreferencesStatusLabel(this.roomPreferencesCount(index), this.roomPreferencesTotal);
  }

  /**
   * Nombre legible de la categoria de habitacion elegida (para la tab).
   */
  private roomCategoryLabel(value: any): string {
    if (!value) {
      return '';
    }
    const labels: Record<string, string> = {
      'Standard': 'Estándar',
      'Deluxe': 'Deluxe',
      'Suite': 'Suite',
      'Excecutive': 'Executive',
      'Otra': 'Otra'
    };
    return labels[value] ?? String(value);
  }

  /**
   * Preferencias legacy de la raiz del producto: la union de las preferencias
   * de todas las habitaciones.
   *
   * El backend actual (OfflineHotelQuoteService::pickRooms) lee meals,
   * cancellationPolicy, category y type_bed de la raiz del producto, asi que
   * estos campos se siguen mandando para que la cotizacion no se rompa hasta
   * que el backend soporte las preferencias por habitacion.
   *
   * - meals / category / type_bed: union (el filtro viejo de regimen ya es OR
   *   y las preferencias blandas se aplican con "alguna de").
   * - cancellationPolicy: es escalar, no se puede expresar por habitacion, asi
   *   que se manda el mas restrictivo (NR > R > C).
   */
  private buildLegacyPreferences(rooms: any[]): { meals: string[]; category: string[]; type_bed: string[]; cancellationPolicy: string | null } {
    const union = (key: string): string[] => {
      const values: string[] = [];
      rooms.forEach(room => {
        (room?.preferences?.[key] || []).forEach((value: string) => {
          if (!values.includes(value)) {
            values.push(value);
          }
        });
      });
      return values;
    };

    const policies = rooms
      .map(room => room?.preferences?.cancellationPolicy)
      .filter((policy: any) => !!policy);
    const cancellationPolicy = ['NR', 'R', 'C'].find(policy => policies.includes(policy)) ?? null;

    return {
      meals: union('meals'),
      category: union('category'),
      type_bed: union('type_bed'),
      cancellationPolicy
    };
  }

  /**
   * Deja el tab activo de preferencias dentro del rango de habitaciones
   * existentes (se llama cuando se reconstruye o se recorta el FormArray).
   */
  private clampActiveRoomTab(): void {
    const roomArray = this.formHotel?.get('room') as FormArray | undefined;
    const length = roomArray?.length ?? 0;
    this.activeRoomTab = length === 0 ? 0 : Math.max(0, Math.min(this.activeRoomTab, length - 1));
  }

  addInitialRoom(): void {
    const roomArray = this.formHotel.get('room') as FormArray;
    roomArray.push(this.createRoomGroup(1, 0, this.formBuilder.array([])));
    this.setRoomAndPassengers();
  }

  /**
   * Maximo de habitaciones permitido en la solicitud offline.
   */
  readonly maxRooms = MAX_OFFLINE_ROOMS;

  /**
   * True cuando ya se alcanzo el maximo de habitaciones: el boton
   * "Agregar Habitacion" se deshabilita y se avisa al usuario.
   */
  get roomsAtMax(): boolean {
    const roomArray = this.formHotel?.get('room') as FormArray | undefined;
    return (roomArray?.length ?? 0) >= this.maxRooms;
  }

  addRoom(event?: Event): void {
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }
    const roomArray = this.formHotel.get('room') as FormArray;
    if (roomArray.length >= MAX_OFFLINE_ROOMS) {
      return;
    }
    // La habitacion nueva arranca con las preferencias de la ultima: es lo que
    // el agente espera (copiar la anterior y ajustar lo que cambie).
    const last = this.roomPreferencesValue(roomArray.length - 1);
    roomArray.push(this.createRoomGroup(1, 0, this.formBuilder.array([]), last));
    this.setRoomAndPassengers();
  }

  removeRoom(index: number, event?: Event): void {
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }
    const roomArray = this.formHotel.get('room') as FormArray;
    if (roomArray.length <= 1) {
      return;
    }
    roomArray.removeAt(index);
    // Si el tab activo era el de la habitacion eliminada (o uno posterior),
    // quedan apuntando a una habitacion que ya no existe.
    this.clampActiveRoomTab();
    this.setRoomAndPassengers();
  }

  incrementPassengerAdult(index: number, event?: Event): void {
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }
    const roomArray = this.formHotel.get('room') as FormArray;
    const roomGroup = roomArray.at(index) as FormGroup;
    const currentValue = roomGroup.get('qtyAdults')?.value || 0;
    if (currentValue >= 10) return;
    roomGroup.patchValue({ qtyAdults: currentValue + 1 });
  }

  decrementPassengerAdult(index: number, event?: Event): void {
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }
    const roomArray = this.formHotel.get('room') as FormArray;
    const roomGroup = roomArray.at(index) as FormGroup;
    const currentValue = roomGroup.get('qtyAdults')?.value || 0;
    if (currentValue <= 1) return;
    roomGroup.patchValue({ qtyAdults: currentValue - 1 });
  }

  incrementPassengerChildren(index: number, item: FormGroup, event?: Event): void {
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }
    const roomArray = this.formHotel.get('room') as FormArray;
    const roomGroup = roomArray.at(index) as FormGroup;
    const currentValue = roomGroup.get('qtyChilds')?.value || 0;
    if (currentValue >= 10) return;
    roomGroup.patchValue({ qtyChilds: currentValue + 1 });
    const ages = item.get('childsage') as FormArray;
    ages.push(this.formBuilder.group({
      id: [currentValue],
      age: [0, [Validators.required, Validators.min(0), Validators.max(17)]]
    }));
  }

  decrementPassengerChildren(index: number, item: FormGroup, event?: Event): void {
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }
    const roomArray = this.formHotel.get('room') as FormArray;
    const roomGroup = roomArray.at(index) as FormGroup;
    const currentValue = roomGroup.get('qtyChilds')?.value || 0;
    if (currentValue <= 0) return;
    roomGroup.patchValue({ qtyChilds: currentValue - 1 });
    const ages = item.get('childsage') as FormArray;
    if (ages.length > 0) {
      ages.removeAt(ages.length - 1);
    }
  }

  getPassengerCountAdult(index: number): number {
    const roomArray = this.formHotel.get('room') as FormArray;
    const roomGroup = roomArray.at(index) as FormGroup;
    return roomGroup.get('qtyAdults')?.value || 0;
  }

  getPassengerCountChildren(index: number): number {
    const roomArray = this.formHotel.get('room') as FormArray;
    const roomGroup = roomArray.at(index) as FormGroup;
    return roomGroup.get('qtyChilds')?.value || 0;
  }

  /**
   * Suma adultos + niños de todos los rooms (Bloque 2, campo "Total de pasajeros").
   */
  getTotalPassengers(): number {
    const roomArray = this.formHotel.get('room') as FormArray;
    if (!roomArray) return 0;
    let total = 0;
    roomArray.controls.forEach((room) => {
      total += Number((room as FormGroup).get('qtyAdults')?.value || 0);
      total += Number((room as FormGroup).get('qtyChilds')?.value || 0);
    });
    return total;
  }

  get hotelNamesArray(): FormArray {
    return this.formHotel.get('hotelNames') as FormArray;
  }

  /**
   * True cuando el usuario ya tipeó al menos un nombre de hotel. Se usa para
   * ocultar la sección "Ampliar información de búsqueda" (bloque 4) cuando
   * ya hay un hotel específico seleccionado — esa sección solo aporta valor
   * cuando el usuario todavía no eligió hotel.
   */
  get hasAnyHotelSelected(): boolean {
    const arr = this.hotelNamesArray;
    if (!arr || arr.length === 0) return false;
    return arr.controls.some((c) => {
      const v = (c.get('name')?.value ?? '').toString().trim();
      return v.length > 0;
    });
  }

  /**
   * Mascara para "Tarifa por noche": formato en-US (coma miles, punto decimal,
   * maximo 2 decimales). El prefijo `ARS` se muestra siempre como bloque fijo
   * al costado del input (ver template), el `<input>` solo guarda los numeros.
   *
   * El FormControl guarda `number | null`. Mientras el usuario tipea solo
   * reformateamos `input.value`; el FormControl se sincroniza en `blur` para
   * evitar que Angular pise el formato cada vez que se hace setValue.
   */
  onPriceNightInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    const raw = input.value;
    const caret = input.selectionStart ?? raw.length;

    // Detectar si el usuario esta tipeando decimales: el caret esta DESPUES
    // de un punto en el valor crudo. Si hay un punto en raw, los ultimos 1-2
    // digitos son decimales, el resto entero.
    const dotIndex = raw.indexOf('.');
    const isTypingDecimals = dotIndex !== -1;

    const digits = raw.replace(/\D/g, '');
    if (digits.length === 0) {
      if (input.value !== '') {
        input.value = '';
      }
      return;
    }

    let formatted: string;
    if (isTypingDecimals) {
      // El usuario puso un '.': los primeros N-2 digitos son enteros, los ultimos 2 decimales.
      const intDigits = digits.slice(0, -2);
      const decDigits = digits.slice(-2);
      const intFormatted = intDigits.length === 0 ? '0' : new Intl.NumberFormat('en-US').format(Number(intDigits));
      formatted = intFormatted + '.' + decDigits;
    } else {
      // Solo enteros: coma como separador de miles.
      formatted = new Intl.NumberFormat('en-US').format(Number(digits));
    }

    if (input.value !== formatted) {
      input.value = formatted;
      // Restaurar caret al final para evitar saltos raros.
      try { input.setSelectionRange(formatted.length, formatted.length); } catch { /* ignore */ }
    }
  }

  /**
   * Al salir del campo, sincroniza el FormControl con el numero parseado.
   * Tambien limpia el formato (ej: "1,234.5" -> "1,234.50" para normalizar).
   */
  onPriceNightBlur(event: Event): void {
    const input = event.target as HTMLInputElement;
    const raw = input.value;
    if (!raw) {
      this.formHotel?.get('price_night')?.setValue(null, { emitEvent: false });
      return;
    }
    const num = Number(raw.replace(/,/g, ''));
    if (!Number.isFinite(num)) {
      this.formHotel?.get('price_night')?.setValue(null, { emitEvent: false });
      return;
    }

    // 1) Sincronizamos el FormControl con el número. Angular reescribe el
    // `input.value` con la representación interna del control (un Number
    // crudo, ej. "1234"), pisando el formato "1,234" que ve el usuario.
    // Por eso el formateo debe ir DESPUÉS de setValue, no antes.
    this.formHotel?.get('price_night')?.setValue(num, { emitEvent: false });

    // 2) Reformateamos el DOM para que el usuario siga viendo "1,234.50"
    // al salir del campo. El "ARS" va en el <span> a la izquierda, NO acá,
    // porque sino `parsePriceNightForBackend()` (`Number(raw)`) rompería con
    // `NaN` al armar el payload.
    const normalized = new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(num);
    if (input.value !== normalized) {
      input.value = normalized;
    }
  }

  /**
   * Formatea el input cuando se carga el edit mode con un valor numerico del backend.
   */
  formatPriceNightInput(value: number | null | undefined): void {
    const input = document.getElementById('price_night') as HTMLInputElement | null;
    if (!input) return;
    if (value === null || value === undefined || !Number.isFinite(value) || value <= 0) {
      input.value = '';
      return;
    }
    input.value = new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(value);
  }

  priceNightMaxValidator() {
    return Validators.max(9999999.99);
  }

  /**
   * Validador del rango de fechas del hotel: el check-in no puede ser anterior
   * a hoy. El daterangepicker ya deshabilita los días pasados (minDate), pero
   * el rango puede llegar precargado (prefill desde la búsqueda o
   * rehidratación en modo edit) y saltarse esa protección.
   */
  dateRangeNotPastValidator = (control: AbstractControl): ValidationErrors | null => {
    const value = control?.value;
    if (!value || typeof value !== 'object' || !value.start) {
      // El "required" del rango (ambos extremos) lo valida el control.
      return null;
    }
    const startDate = dayjs(value.start as any);
    if (!startDate.isValid()) {
      return null;
    }
    return startDate.isBefore(dayjs().startOf('day'), 'day') ? { dateInPast: true } : null;
  };

  /**
   * Validador de la nacionalidad: el valor tiene que venir de una opción de la
   * lista de países. No alcanza con escribir un texto: si el agente tipea sin
   * elegir una opción, el campo queda inválido.
   *
   * El campo sigue siendo opcional (vacío = válido); lo que no se permite es
   * un valor inventado.
   */
  nationalityValidator = (control: AbstractControl): ValidationErrors | null => {
    const value = (control?.value ?? '').toString().trim();
    if (!value) {
      return null;
    }
    return this.nationalitySelected ? null : { nationalityNotSelected: true };
  };

  passengerValidator = (group: AbstractControl) => {
    const requestType = this.formHotel?.get('requestType')?.value;
    if (requestType === 'quotation') {
      return null;
    }
    const v = group.value;
    if (v.id != null) {
      return null;
    }
    const fn = (v.first_name || '').trim();
    const ln = (v.last_name || '').trim();
    return fn && ln ? null : { passengerRequired: true };
  };

  experiencePassengerValidator = (group: AbstractControl): ValidationErrors | null => {
    const requestType = this.formExperience?.get('requestType')?.value;
    if (requestType === 'quotation') {
      return null;
    }
    const v = group.value;
    if (v.id != null && v.id !== '') {
      return null;
    }
    const fn = (v.first_name || '').trim();
    const ln = (v.last_name || '').trim();
    return fn && ln ? null : { passengerRequired: true };
  };

  transferPassengerValidator = (group: AbstractControl): ValidationErrors | null => {
    const requestType = this.formTransfer?.get('requestType')?.value;
    if (requestType === 'quotation') {
      return null;
    }
    const v = group.value;
    if (v.id != null && v.id !== '') {
      return null;
    }
    const fn = (v.first_name || '').trim();
    const ln = (v.last_name || '').trim();
    return fn && ln ? null : { passengerRequired: true };
  };

  /**
   * Si hay niños cargados, la edad de cada uno es obligatoria (mismo criterio
   * que el formulario de traslados del diseño React).
   */
  transferChildAgesValidator = (array: AbstractControl): ValidationErrors | null => {
    const children = Number(array.parent?.get('children')?.value || 0);
    if (!children) return null;

    const ages = (array.value || []) as any[];
    if (ages.length !== children) return { childAgesRequired: true };
    if (ages.some(age => age === null || age === undefined || age === '')) {
      return { childAgesRequired: true };
    }
    return null;
  };

  transferDateRangeValidator = (group: AbstractControl): ValidationErrors | null => {
    const pickup = group.get('pickupDate')?.value;
    const ret = group.get('returnDate')?.value;
    const pickupTime = group.get('pickupTime')?.value;
    const retTime = group.get('returnTime')?.value;
    if (ret && pickup && ret < pickup) return { dateRange: true };
    if (ret && pickup && ret === pickup && retTime && pickupTime && retTime <= pickupTime) return { dateTimeRange: true };
    if (ret && !retTime) return { returnTimeRequired: true };
    if (retTime && !ret) return { returnDateRequired: true };
    return null;
  };

  /**
   * Devuelve el valor numerico del FormControl price_night, o null si esta vacio.
   */
  parsePriceNightForBackend(): number | null {
    const raw = this.formHotel?.get('price_night')?.value;
    if (raw === null || raw === undefined || raw === '') {
      return null;
    }
    const num = Number(raw);
    return Number.isFinite(num) ? num : null;
  }

  /**
   * Setea el valor estimado por noche en el control `estimatedRate`. El control
   * es disabled, y patchValue sobre un control disabled actualiza el valor
   * interno pero la UI no lo refleja: por eso lo habilitamos al pasar y lo
   * volvemos a deshabilitar.
   *
   * El control guarda el valor YA FORMATEADO (ej: 12 -> "12.00",
   * 1234.5 -> "1,234.50") porque es lo que se muestra en el input. El numero
   * crudo para el payload lo devuelve `estimatedRateValue()`, que lo parsea.
   */
  private setEstimatedRateValue(value: number | null): void {
    const control = this.formHotel?.get('estimatedRate');
    if (!control) {
      return;
    }
    const wasDisabled = control.disabled;
    if (wasDisabled) {
      control.enable({ emitEvent: false });
    }
    control.patchValue(formatAmountEnUs(value), { emitEvent: false });
    if (wasDisabled) {
      control.disable({ emitEvent: false });
    }
  }

  /**
   * Devuelve el valor estimado por noche (costo referencial del hotel) como
   * numero, o null si el hotel no tiene referencial. El control `estimatedRate`
   * es disabled, asi que no aparece en `formHotel.value` y hay que leerlo
   * directo. El control guarda el valor formateado ("1,234.50"), asi que hay
   * que sacarle los separadores de miles antes de convertirlo a numero.
   */
  estimatedRateValue(): number | null {
    return parseAmountEnUs(this.formHotel?.get('estimatedRate')?.value);
  }

  get totalPassengersLabel(): string {
    const rooms = this.formHotel.get('room') as FormArray;
    if (!rooms) return '0';
    let total = 0;
    rooms.controls.forEach((r) => {
      total += Number(r.get('qtyAdults')?.value || 0);
      total += Number(r.get('qtyChilds')?.value || 0);
    });
    return String(total);
  }

  addHotelName(): void {
    const hotels = this.formHotel.get('hotelNames') as FormArray;
    if (!hotels) return;
    hotels.push(this.formBuilder.group({
      name: new FormControl('', [Validators.required, Validators.maxLength(100)])
    }));
  }

  removeHotelName(index: number): void {
    const hotels = this.formHotel.get('hotelNames') as FormArray;
    if (!hotels) return;
    if (hotels.length > 1) {
      hotels.removeAt(index);
    }
  }

  validatePassengerInput(event: any, index: number): void {
    const value = parseInt(event.target.value, 10);
    if (isNaN(value) || value < 1) {
      event.target.value = 1;
    } else if (value > 10) {
      event.target.value = 10;
    }
  }

  handleAdultInput(event: KeyboardEvent, index: number): void {
    const allowed = /[0-9]/;
    if (!allowed.test(event.key) && event.key !== 'Backspace' && event.key !== 'Delete' && event.key !== 'ArrowLeft' && event.key !== 'ArrowRight' && event.key !== 'Tab') {
      event.preventDefault();
    }
  }

  handleChildrenInput(event: KeyboardEvent, index: number): void {
    const allowed = /[0-9]/;
    if (!allowed.test(event.key) && event.key !== 'Backspace' && event.key !== 'Delete' && event.key !== 'ArrowLeft' && event.key !== 'ArrowRight' && event.key !== 'Tab') {
      event.preventDefault();
    }
  }

  handleAdultBlur(event: any, index: number): void {
    let value = parseInt(event.target.value, 10);
    if (isNaN(value) || value < 1) value = 1;
    if (value > 10) value = 10;
    event.target.value = value;
    const roomArray = this.formHotel.get('room') as FormArray;
    const roomGroup = roomArray.at(index) as FormGroup;
    roomGroup.patchValue({ qtyAdults: value });
  }

  handleChildrenBlur(event: any, index: number): void {
    let value = parseInt(event.target.value, 10);
    if (isNaN(value) || value < 0) value = 0;
    if (value > 10) value = 10;
    event.target.value = value;
    const roomArray = this.formHotel.get('room') as FormArray;
    const roomGroup = roomArray.at(index) as FormGroup;
    const currentChilds = roomGroup.get('qtyChilds')?.value || 0;
    const ages = roomGroup.get('childsage') as FormArray;
    if (value > currentChilds) {
      for (let i = currentChilds; i < value; i++) {
        ages.push(this.formBuilder.group({
          id: [i],
          age: [0, [Validators.required, Validators.min(0), Validators.max(17)]]
        }));
      }
    } else if (value < currentChilds) {
      for (let i = currentChilds; i > value; i--) {
        ages.removeAt(ages.length - 1);
      }
    }
    roomGroup.patchValue({ qtyChilds: value });
  }

  preventModalClose(event: MouseEvent): void {
    event.stopPropagation();
    event.preventDefault();
  }

  openModal(): void {
    this.isCollapsed = true;
  }

  closeModal(): void {
    this.isCollapsed = false;
  }

  setRoomAndPassengers(): void {
    const roomArray = this.formHotel.get('room') as FormArray;
    const rooms = roomArray.value;
    const roomsCount = rooms.length;
    let adults = 0;
    let childs = 0;
    rooms.forEach((r: any) => {
      adults += Number(r.qtyAdults) || 0;
      childs += Number(r.qtyChilds) || 0;
    });
    const noSelected = adults === 0 && childs === 0;
    const roomsStr = roomsCount === 1 ? roomsCount + ' Habitación' : roomsCount + ' Habitaciones';
    const adultsStr = adults !== undefined ? ' - ' + adults + ' Adultos' : '';
    const childsStr = childs !== undefined ? ' - ' + childs + ' Niños' : '';
    this.roomsAndPassengers = noSelected ? 'Rooms and passengers' : roomsStr + adultsStr + childsStr;
  }

  agesChildsArr(): string[] {
    return Array.from({ length: 18 }, (_, index) => index.toString());
  }

  private syncRoomToFlatModel(): void {
    const roomArray = this.formHotel.get('room') as FormArray;
    const rooms = roomArray.value;
    const qty_rooms = rooms.length;
    let adults = 0;
    let childs = 0;
    const allAges: number[] = [];

    rooms.forEach((r: any) => {
      adults += Number(r.qtyAdults) || 0;
      const roomChilds = Number(r.qtyChilds) || 0;
      childs += roomChilds;
      const childsage: any[] = r.childsage || [];
      childsage.forEach((child: any) => {
        const age = Number(child.age);
        if (!isNaN(age) && age >= 0 && age <= 17) {
          allAges.push(age);
        }
      });
    });

    const age_childs = allAges.length > 0 ? allAges.join(', ') : null;

    // Nota: NO hacemos patchValue en formHotel con adults/childs/age_childs/qty_rooms
    // porque esos controles ya no existen en el FormGroup (fueron reemplazados
    // por el FormArray `room`). `buildPayloadHotel` lee directo del FormArray
    // y arma el shape plano que espera el backend.
    this.formHotelEdited = true;
  }

  confirmRoomsAndPassengers(event?: Event): void {
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }
    this.syncRoomToFlatModel();
    this.isCollapsed = false;
    this.setRoomAndPassengers();
  }

  updateButtonColorRoom(): void {
    const button = document.querySelector('.btn-choice-add') as HTMLElement;
    if (this.isHoverRoom) {
      button.style.backgroundColor = this.bgClientColor;
    } else {
      button.style.backgroundColor = 'white';
    }
  }

  updateButtonColorConfirm(): void {
    const button = document.querySelector('.btn-choice-confirm') as HTMLElement;
    if (this.isHoverConfirm) {
      button.style.backgroundColor = this.bgClientColor;
    } else {
      button.style.backgroundColor = 'white';
    }
  }

  /**
 * Método para intercambiar las ubicaciones de origen y destino.
 *
 * Este método intercambia los valores de origen y destino en el formulario. Los valores se toman de los campos
 * `firstOrigin` y `firstDestination` y luego se aplican en el formulario usando `patchValue`.
 */
swapLocations() {
  // Intercambiar valores del formulario (primer traslado: los traslados son
  // independientes entre sí, cada uno tiene su propio origen/destino).
  const transfers = this.formTransfer.get('transfers') as FormArray;
  const transfer = transfers?.at(0);
  if (!transfer) {
    return;
  }
  const origin = transfer.get('origin')?.value;
  const destination = transfer.get('destination')?.value;

  transfer.patchValue({
    origin: destination,
    destination: origin
  });

  // Intercambiar pickup y dropoff
  const tempPickup = this.pickup;
  this.pickup = this.dropoff;
  this.dropoff = tempPickup;

  // Intercambiar códigos IATA
  const tempIata = this.selectediataCodeOrigin;
  this.selectediataCodeOrigin = this.selectediataCodeDestiny;
  this.selectediataCodeDestiny = tempIata;

  // Intercambiar los valores visuales de los inputs
  const tempInputValue = this.originInputValue;
  this.originInputValue = this.destinationInputValue;
  this.destinationInputValue = tempInputValue;
}

/**
 * Método para manejar el cambio de fecha.
 *
 * Este método se utiliza para establecer la fecha de llegada en el formulario y la hora actual,
 * o para restablecer la fecha si el valor es `null`.
 *
 * @value -> valor de tipo Date que representa la nueva fecha de llegada seleccionada.
 */
onDateChange(value: Date | null) {
  // Opera sobre el primer traslado (cada traslado tiene su propia vuelta).
  const transfers = this.formTransfer.get('transfers') as FormArray;
  const transfer = transfers?.at(0);
  if (!transfer) {
    return;
  }
  if (value) {
    this.oneWay = false;
    transfer.get('returnDate').setValue(value);
    transfer.get('returnTime').setValue(this.currentTime);
  } else {
    transfer.get('returnDate').setValue(null);
  }
}

onChangeSelectForm(event: any, form: string, control: string): void {
console.log(event)
  let controlForm;
  switch(form) {
    case 'hotel':
      controlForm = this.formHotel.get(`${control}`) as FormArray;
      break;
    case 'transfer':
      controlForm = this.formTransfer.get(`${control}`) as FormArray;
      break;
    case 'rent-a-car':
      controlForm = this.formRentACar.get(`${control}`) as FormArray;
      break;
  }

  if (event.target.checked) {
    controlForm.push(new FormControl(event.target.value));
  } else {
    const index = controlForm.controls.findIndex(ctrl => ctrl.value === event.target.value);
    if (index !== -1) {
      controlForm.removeAt(index);
    }
  }
}

/**
 * NOTA: el radio button de "Política de cancelación" usa `formControlName="cancellationPolicy"`
 * directamente, así que Angular Forms maneja el bind sin lógica custom.
 * Si en el futuro hay que agregar comportamiento (ej. log, telemetría), se hace acá.
 */
// (Método intencionalmente vacío — reservado para futuras extensiones.)

  /**
   * Abre la sección colapsable "Expandir tu búsqueda".
   * NO dispara búsqueda automáticamente: el usuario debe tipear el nombre
   * del hotel y hacer click en "Buscar".
   */
  openHotelSuggestSection(): void {
    this.hotelSuggestSectionOpen = true;
    this.showHotelSuggest = true;
    // Cerramos el dropdown de searchLocations del input hotelsName
    // para que no compita visualmente con la nueva sección.
    this.closeHotelsNameAutocomplete = true;
    if (this.hotelsNameTrigger) {
      this.hotelsNameTrigger.closePanel();
    }
  }

  /**
   * Cierra la sección colapsable y limpia el estado de búsqueda.
   */
  closeHotelSuggestSection(): void {
    this.hotelSuggestSectionOpen = false;
    this.showHotelSuggest = false;
    this.closeHotelsNameAutocomplete = false;
    this.hotelSuggestSearchInput = '';
    this.closeHotelSuggest();
  }

  /**
   * Handler del ngModelChange del input de hotel en Block 4.
   * Emite el valor al subject de debounce — la búsqueda se dispara
   * 500ms después de la última tecla tipeada.
   */
  onHotelSuggestInputChange(value: string): void {
    this.hotelSuggestDebounce$.next(value ?? '');
  }

  /**
   * Cuando el input del Block 4 toma foco, cerramos el autocomplete
   * del campo "Nombre del hotel" del Bloque 2 para que no haya
   * dos dropdowns abiertos a la vez.
   */
  onHotelSuggestFocus(): void {
    this.closeHotelsNameAutocomplete = true;
  }

  /**
   * Limpia el input de Block 4, los resultados y el error.
   * Llamado desde el botón "Limpiar" del input.
   */
  onHotelSuggestClear(): void {
    this.hotelSuggestSearchInput = '';
    this.hotelSuggestResults = [];
    this.hotelSuggestError = null;
  }

  /**
   * Handler del click en una card de sugerencia. Setea el input al nombre
   * del hotel seleccionado. NO toca el campo "Nombre del hotel" del Bloque 2
   * — el input del Block 4 es independiente.
   */
  onHotelSuggestSelect(hotel: any): void {
    if (!hotel) return;
    this.hotelSuggestSearchInput = hotel.name || hotel.hotel_name || '';
  }

  /**
   * Handler del mat-autocomplete cuando el usuario selecciona una opción
   * del dropdown. Setea el input al nombre del hotel.
   */
  onHotelSuggestSelected(hotel: any): void {
    if (!hotel) return;
    this.hotelSuggestSearchInput = hotel.name || hotel.hotel_name || '';
  }

  /**
   * Dispara la búsqueda de sugerencias con el texto que el usuario tipeó
   * en el input de la sección. Filtra por la ciudad del campo destination
   * si está disponible.
   *
   * Llamado SOLO cuando el usuario hace click en el botón "Buscar".
   */
  runHotelSuggestSearch(): void {
    const name = (this.hotelSuggestSearchInput || '').trim();
    if (!name) {
      this.hotelSuggestError = 'Escribe un nombre de hotel para buscar.';
      return;
    }

    // Tomamos la ciudad de destination (puede ser objeto o string).
    const dest = this.formHotel.get('destination')?.value;
    let city = '';
    if (dest && typeof dest === 'object') {
      city = dest.city_name || '';
    } else if (typeof dest === 'string') {
      city = dest;
    }

    this.searchHotelSuggestWith(name, city);
  }

  /**
   * Helper: dispara la búsqueda con los params dados (sin tocar el state de
   * hotelSuggestName/City que ya no usamos como inputs editables).
   */
  private searchHotelSuggestWith(name: string, city: string): void {
    this.hotelSuggestLoading = true;
    this.hotelSuggestError = null;
    this.hotelSuggestResults = [];

    const params: any = { name, enrich: 3, enrich_limit: 3 };
    if (city && city.trim()) {
      params.city = city.trim();
    }

    this.restService.doGet('app', 'contact/hotels/suggest', { params })
      .subscribe({
        next: (res: any) => {
          this.hotelSuggestLoading = false;
          this.hotelSuggestResults = res?.data?.suggestions || [];
          if (this.hotelSuggestResults.length > 0) {
            setTimeout(() => this.hotelSuggestInput?.openPanel(), 0);
          } else {
            this.hotelSuggestError = 'No encontramos sugerencias para ese hotel.';
          }
        },
        error: (err) => {
          this.hotelSuggestLoading = false;
          this.hotelSuggestError = 'No pudimos buscar hoteles. Intenta de nuevo.';
          console.error('[hotelSuggest] error', err);
        }
      });
  }

  /**
   * Selecciona una sugerencia de la lista. Dispara el GET al endpoint `run`
   * con el run_id de esa sugerencia. Cuando devuelve los datos completos,
   * re-dispara la búsqueda de `searchlocations` para que el hotel recién
   * creado aparezca en el autocomplete principal.
   */
  selectHotelSuggestion(hotel: any): void {
    if (!hotel) {
      return;
    }
    const runId = hotel.run_id;
    const hotelName = hotel.name || hotel.hotel_name || '';
    if (!runId) {
      this.hotelSuggestError = 'La sugerencia no tiene run_id';
      return;
    }

    this.hotelSuggestEnriching = true;
    this.hotelSuggestError = null;
    this.hotelSuggestPending = false;

    this.restService.doGet('app', 'contact/hotels/suggest/run', {
      params: { run_id: runId }
    }).subscribe({
      next: (res: any) => {
        this.hotelSuggestEnriching = false;
        // El run devuelve la data enriquecida. Si todavía está pending,
        // avisamos y dejamos que el usuario reintente.
        const enrichmentStatus = res?.data?.enrichment?.status;
        if (enrichmentStatus === 'pending') {
          this.hotelSuggestPending = true;
          return;
        }
        // Datos completos: re-buscamos en searchlocations con el nombre
        // del hotel creado para que aparezca en el autocomplete principal.
        this.reloadHotelsNameAutocomplete(hotelName || hotel.requested_name);
      },
      error: (err) => {
        this.hotelSuggestEnriching = false;
        this.hotelSuggestError = 'No pudimos obtener los datos completos. Intenta de nuevo.';
        console.error('[hotelSuggest/run] error', err);
      }
    });
  }

  /**
   * Re-dispara la búsqueda de searchlocations con el nombre del hotel recién
   * creado. Cuando el autocomplete traiga resultados, automáticamente
   * seleccionamos el primero que matchee el nombre y cerramos el selector.
   */
  private reloadHotelsNameAutocomplete(name: string): void {
    if (!name) {
      this.hotelNamesArray.at(0).get('name')?.setValue(name);
      this.formHotelEdited = true;
      this.closeHotelSuggest();
      return;
    }

    // Disparamos la búsqueda manualmente usando el mismo endpoint.
    this.restService.doGet('app', `search-locations/${encodeURIComponent(name)}?category=HOTELS`)
      .subscribe({
        next: (res: any) => {
          const hotels = res?.hotels || [];
          // Buscamos el hotel que matchee por nombre (case-insensitive).
          const match = hotels.find((h: any) =>
            h?.name && name && h.name.toLowerCase().includes(name.toLowerCase())
          );
          if (match) {
            this.hotelNamesArray.at(0).get('name')?.setValue(match);
            this.onHotelsNameSelected(match);
          } else {
            // Si no matchea por nombre, igual dejamos el nombre en el input.
            this.hotelNamesArray.at(0).get('name')?.setValue(name);
            this.formHotelEdited = true;
          }
          this.closeHotelSuggest();
        },
        error: () => {
          // Si falla la búsqueda, igual dejamos el nombre tipeado.
          this.hotelNamesArray.at(0).get('name')?.setValue(name);
          this.formHotelEdited = true;
          this.closeHotelSuggest();
        }
      });
  }

  /**
   * Cierra el selector y limpia estado temporal.
   */
  closeHotelSuggest(): void {
    this.showHotelSuggest = false;
    this.closeHotelsNameAutocomplete = false;
    this.hotelSuggestResults = [];
    this.hotelSuggestError = null;
    this.hotelSuggestPending = false;
  }

  /**
   * Abre el modal de selección de clientes (ClientListModalComponent) ya existente
   * en el proyecto. Reutiliza el mismo endpoint y patrón que itinerary-owner.
   */
  openClientListModal(): void {
    const initialState: ModalOptions = {
      initialState: {
        clientEmail: this.formHotel.get('client.email')?.value ?? '',
      },
      class: 'modal-lg modal-edit-search',
    };
    this.bsModalRef = this.modalService.show(ClientListModalComponent, initialState);

    this.bsModalRef.content.clientSelected.subscribe((client: any) => {
      this.onClientSelected(client);
    });
  }

  /**
   * Maneja el cliente emitido por el modal. Pinta el sub-FormGroup y marca
   * el form como editado. Si el cliente trae phone_code (lo resuelve el modal
   * via countriesData), lo usamos; si no, lo dejamos para que el usuario lo complete.
   */
  onClientSelected(client: any): void {
    if (!client) {
      return;
    }
    this.selectedClient = client;
    this.formHotel.get('client')?.patchValue({
      client_id: client.id,
      title: client.title ?? null,
      first_name: client.first_name ?? null,
      last_name: client.last_name ?? null,
      email: client.email ?? null,
      phone_code: client.phone_code_number ?? client.phone_code ?? null,
      phone: client.phone ?? null
    });

    this.formExperience.get('client')?.patchValue({
      client_id: client.id,
      first_name: client.first_name ?? null,
      last_name: client.last_name ?? null,
      email: client.email ?? null,
      phone_code: client.phone_code_number ?? client.phone_code ?? null,
      phone: client.phone ?? null
    });

    // Si el modal ya resolvió el phone_code_resolved, lo guardamos en el state
    // para que el input lo muestre legible (ej: "Argentina (+54)").
    if (client.phone_code_resolved) {
      this.phoneCodeSelected = client.phone_code_resolved;
    }

    this.formHotelEdited = true;
  }

  /**
   * Carga la lista de países para el autocomplete de phone_code del sub-form
   * de cliente. Mismo endpoint que usa itinerary-owner: `/utilities/countries`.
   */
  loadCountries(): void {
    this.restService.doGet('app', 'utilities/countries')
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: any) => {
          this.countriesData = res?.Countrys || res?.countries || [];
        },
        error: () => {
          this.countriesData = [];
        }
      });
  }

  /**
   * Cuando el usuario selecciona un país del autocomplete, guardamos el objeto
   * completo en `phoneCodeSelected` (para mostrar el label legible) y solo el
   * `phone_code` numérico en el FormControl.
   */
  onCountrySelected(country: any): void {
    if (!country) {
      return;
    }
    this.phoneCodeSelected = `${country.country_name} (+${country.phone_code})`;
    this.formHotel.get('client.phone_code')?.setValue(country.phone_code);
  }

  /**
   * displayWith para el mat-autocomplete de phone_code.
   * Devuelve "Country (+phone_code)" si está seleccionado, o el string crudo
   * si el usuario está tipeando.
   */
  displayCountryFn = (value: any): string => {
    if (!value) {
      return '';
    }
    if (typeof value === 'string') {
      return value;
    }
    return `${value.country_name} (+${value.phone_code})`;
  };

  /**
   * Abre el autocomplete de nacionalidad con la lista completa de países.
   * Reusa `countriesData`, que ya se carga en ngOnInit via loadCountries().
   */
  getNationalities(): void {
    this.filteredNationalities = this.countriesData;
  }

  /**
   * Filtra la lista de países por el texto tipeado en el input de nacionalidad.
   *
   * Si el agente escribe a mano (sin elegir una opción), el valor deja de ser
   * una selección válida: se marca el flag y se revalida el control para que
   * aparezca el error.
   */
  filterNationalities(searchText: string): void {
    if (this.nationalitySelected) {
      this.nationalitySelected = false;
      this.formHotel.get('nationality')?.updateValueAndValidity();
    }
    if (!searchText) {
      this.filteredNationalities = this.countriesData;
      return;
    }
    const term = searchText.toLowerCase();
    this.filteredNationalities = this.countriesData.filter(
      country => country?.country_name?.toLowerCase().includes(term)
    );
  }

  /**
   * Selección de nacionalidad. Guardamos el NOMBRE del país en el FormControl
   * (no el country_code) para no cambiar el contrato del payload offline.
   */
  onNationalitySelected(countryName: string): void {
    if (!countryName) {
      return;
    }
    this.selectNationalityName = countryName;
    // El flag va antes del setValue: el validador corre en el setValue.
    this.nationalitySelected = true;
    this.formHotel.get('nationality')?.setValue(countryName);
  }

  /**
   * Limpia la nacionalidad y vuelve al input con autocomplete.
   *
   * OJO: a diferencia de hotels, acá NO hacemos setErrors({error: true}),
   * porque `nationality` es opcional en el form offline (está en OPTIONAL_KEYS
   * de canEditCompetitor). Forzar el error apagaría la sección Competencia.
   */
  resetNationality(): void {
    this.selectNationalityName = '';
    this.nationalitySelected = false;
    this.formHotel.get('nationality')?.setValue(null);
    this.filteredNationalities = this.countriesData;
  }

  /**
   * Quita el cliente seleccionado. Limpia el sub-FormGroup y el state.
   */
  clearSelectedClient(): void {
    this.selectedClient = null;
    this.phoneCodeSelected = null;
    this.formHotel.get('client')?.reset({
      client_id: null,
      title: null,
      first_name: null,
      last_name: null,
      email: null,
      phone_code: null,
      phone: null
    });
  }

resetForm(type): void {
  switch(type) {
    case 'hotel':
      // this.initFormHotel();
      this.formHotel.reset();
      // Reset vuelve todo a null; re-aplicamos el default de requestType
      // para que cotización quede preseleccionado otra vez.
      this.formHotel.patchValue({ requestType: 'quotation' });
      this.clearSelectedClient();
      // Marcamos como editado porque ya hay un valor por defecto cargado.
      this.formHotelEdited = true;
    break;
    case 'transfer': {
      // this.initFormHotel();
      this.formTransfer.reset();
      // Los traslados se vacían y se deja uno vacío listo para cargar
      // (el `reset()` del FormGroup no cambia el largo del array).
      const transfers = this.formTransfer.get('transfers') as FormArray;
      transfers.clear();
      transfers.push(this.createTransferGroup());
      this.formTransferEdited = false;
    break;
    }
    case 'rent-a-car':
      // this.initFormHotel();
      this.formRentACar.reset();
      this.formRentACarEdited = false;
    break;
  }
}

fixCalendarPosition(): void {
  if(this.picker) {
    this.picker.open();

    setTimeout(() => {
      const pickerElement = document.querySelector('ngx-daterangepicker-material') as HTMLElement;
      const inputElement = document.querySelector('.input-ngxDateRangePicker') as HTMLElement;

      if (pickerElement && inputElement) {
        const inputRect = inputElement.getBoundingClientRect();
        const pickerRect = pickerElement.getBoundingClientRect();
        const viewportWidth = window.innerWidth;
        const viewportHeight = window.innerHeight;

        // Posición FIJA a la derecha del input
        let rightPosition = inputRect.left + window.scrollX + 5; // 5px de margen
        let topPosition = inputRect.top + window.scrollY;

        // Verificar si cabe a la derecha, si no, ajustar al borde derecho
        if (rightPosition + pickerRect.width > viewportWidth) {
          rightPosition = viewportWidth - pickerRect.width - 10; // 10px de margen del borde
        }

        // Verificar posición vertical - asegurar que no se salga
        if (topPosition + pickerRect.height > viewportHeight) {
          topPosition = viewportHeight - pickerRect.height - 10; // Alinear con parte inferior
        }

        // Aplicar estilos para posición fija a la derecha
        pickerElement.style.position = 'fixed';
        pickerElement.style.top = `${topPosition}px`;
        pickerElement.style.right = `${rightPosition}px`;
        pickerElement.style.transform = 'none';
        pickerElement.style.zIndex = '99999';
        pickerElement.style.margin = '0';
      }
    }, 0);
  }
}
adjustPickerPosition(pickerElement: HTMLElement, inputRect: DOMRect) {
  const pickerRect = pickerElement.getBoundingClientRect();
  const viewportHeight = window.innerHeight;
  const viewportWidth = window.innerWidth;

  // Ajuste vertical (si no cabe abajo, mostramos arriba)
  if (pickerRect.bottom > viewportHeight) {
    pickerElement.style.top = `${inputRect.top + window.scrollY - pickerRect.height}px`;
  }

  // Ajuste horizontal (si no cabe a la derecha, alineamos a la izquierda)
  if (pickerRect.right > viewportWidth) {
    pickerElement.style.left = `${viewportWidth - pickerRect.width - 10}px`;
  }
}

limitNumber(event: KeyboardEvent, max: number) {
    const input = event.target as HTMLInputElement;
    const value = input.value + event.key;

  if (Number(value) > max) {
    event.preventDefault();
  }
}

     /**
   * Bloquea la entrada de caracteres no deseados (`e`, `E`, `+`, `-`) en campos numéricos.
   * @param event El evento de teclado.
   */
blockInvalidKeys(event: KeyboardEvent, input?: string) {
    const key = event.key;

    switch (input) {
        case 'name':
            // Permitir teclas especiales: Backspace, Delete, Tab, Escape, Enter, y las flechas
            if (
              [
                'Backspace',
                'Delete',
                'Tab',
                'Escape',
                'Enter',
                'ArrowLeft',
                'ArrowRight',
              ].includes(key)
            ) {
              return; // Permitir estas teclas
            }

            // Bloquear caracteres que no coincidan con letras, acentos, ñ o espacios
            if (!/^[a-zA-ZÀ-ÿ\u00f1\u00d1\s]$/.test(key)) {
              event.preventDefault();
            }
            break;

        case 'number':
            if (['e', 'E', '+', '-', ',', '.'].includes(key)) {
                event.preventDefault();
              }
            break;
        case 'price':
            if (['e', 'E', '+', '-',].includes(key)) {
                event.preventDefault();
              }
            break;

        case 'age_childs':
             // Permitir teclas especiales: Backspace, Delete, Tab, Escape, Enter, y las flechas
                if (
                    [
                        'Backspace',
                        'Delete',
                        'Tab',
                        'Escape',
                        'Enter',
                        'ArrowLeft',
                        'ArrowRight',
                        'Home',
                        'End'
                    ].includes(key)
                ) {
                    return; // Permitir estas teclas
                }

                // Permitir números (0-9), comas y espacios
                if (!/^[0-9,\s]$/.test(key)) {
                    event.preventDefault();
                }
            break;
                }
      }

      /**
 * Limita los decimales a máximo 2 después del punto/coma
 */
limitDecimals(event: Event) {
    const input = event.target as HTMLInputElement;
    let value = input.value;

    // Reemplazar coma por punto para consistencia
    value = value.replace(',', '.');

    // Verificar si tiene decimales
    if (value.includes('.')) {
        const parts = value.split('.');

        // Si hay más de 2 decimales, truncar a 2
        if (parts[1] && parts[1].length > 2) {
            parts[1] = parts[1].substring(0, 2);
            value = parts[0] + '.' + parts[1];
        }

        // Actualizar el valor
        input.value = value;
    }
}

/**
   * Configura el autocomplete del campo "Nombre de hoteles".
   *
   * Bifurca la fuente según si hay ciudad seleccionada en el destino:
   *  - Con IATA -> filtra localmente sobre `hotelsByCityCache` (poblado por
   *    `fetchHotelsByCity` al seleccionar la ciudad). NO se pega al backend.
   *  - Sin IATA -> fallback a /utilities/searchlocations/{keyword}?category=HOTELS
   *    (comportamiento previo).
   *
   * Debounce 300ms para no saturar el endpoint mientras el usuario tipea
   * en la rama sin IATA (con IATA es trabajo en memoria).
   * distinctUntilChanged evita re-disparar si el valor no cambió (ej: cuando
   * el autocomplete reescribe el input con displayWith).
   * switchMap cancela el request en vuelo si el usuario sigue tipeando.
   */
  setupHotelsNameAutocomplete(): void {
    const ctrl = this.hotelNamesArray.at(0).get('name');
    if (!ctrl) {
      console.error('[hotelNames] hotelNames[0].name control NOT FOUND in formHotel');
      return;
    }
    this.hotelsNameSearch$
      .pipe(
        debounceTime(300),
        distinctUntilChanged(),
        switchMap((keyword: string) => {
          const iata = this.selectedDestinationIata;
          if (iata) {
            // Rama con ciudad: filtramos el cache en memoria. No llamamos al endpoint.
            const term = (keyword || '').toString().toLowerCase().trim();
            const filtered = term.length >= 2
              ? this.hotelsByCityCache.filter((h: any) => (h.name || '').toLowerCase().includes(term))
              : this.hotelsByCityCache;
            return of({ hotels: filtered });
          }
          // Rama fallback: searchlocations con keyword.
          if (!keyword || keyword.length < 3) {
            return of(null);
          }
          const safe = encodeURIComponent(keyword);
          const req$ = this.restService.doGet('app', `search-locations/${safe}?category=HOTELS`);
          return req$.pipe(
            tap({
              error: (err: any) => {
                console.error('[hotelsName] searchLocations failed', {
                  keyword,
                  status: err?.status,
                  url: err?.url,
                  body: err?.error
                });
              }
            })
          );
        }),
        takeUntil(this.destroy$)
      )
      .subscribe({
        next: (res: any) => {
          if (!res) {
            this.hotelsNameOptions = [];
            return;
          }
          this.hotelsNameOptions = [
            {
              hotels: res?.hotels || [],
              type: 'hotel',
            },
          ];
        },
        error: () => {
          this.hotelsNameOptions = [];
        },
      });

    // Conectar el valueChanges del control al Subject.
    this.hotelNamesArray.at(0).get('name')?.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe((value: any) => {
        if (value && typeof value === 'object') {
          return;
        }
        this.hotelsNameSearch$.next(value || '');
      });
  }

  /**
   * Mapea la respuesta de /utilities/hotels-by-city-iata/{iata} al shape
   * que consume el template (campos `name`, `city_name`, `city_province`,
   * `country_name`, `country_logo`, `id`, `hotel_star_rating`).
   *
   * Endpoint nuevo devuelve res.results[] con:
   *   { id, hotel_name, hotel_star_rating, city_iata, destination_name,
   *     hotel_city, hotel_address, country_code, latitude, longitude, city_id }
   *
   * El template usa `hotel.country_logo` para la banderita; cuando
   * `country_code` es un ISO-2 ('AR', 'BR', etc.) armamos una URL razonable
   * apuntando al flag CDN que ya usa el search-box. Si no podemos resolverlo,
   * dejamos string vacío y el template cae al fallback visual.
   */
  private mapHotelsByCityResults(res: any): any[] {
    const results = res?.results || [];
    return results.map((h: any) => ({
      id: h.id,
      name: h.hotel_name,
      city_name: h.hotel_city,
      city_province: h.destination_name,
      country_name: h.country_code,
      country_logo: h.country_code ? `https://flagcdn.com/w40/${String(h.country_code).toLowerCase()}.png` : '',
      hotel_star_rating: h.hotel_star_rating,
      city_iata: h.city_iata,
      hotel_address: h.hotel_address,
    }));
  }

  /**
   * Configura el autocomplete del campo "Destino".
   * Llama al mismo endpoint SIN category (o con category=HOTELS, da igual) y filtra
   * SOLO ciudades en el front, descartando hoteles, airports y airlines.
   *
   * Mismo patrón de debounce/distinct/switchMap que hotelsName.
   */
  setupDestinationAutocomplete(): void {
    const ctrl = this.formHotel.get('destination');
    if (!ctrl) {
      console.error('[destination] destination control NOT FOUND in formHotel');
      return;
    }
    this.destinationSearch$
      .pipe(
        debounceTime(300),
        distinctUntilChanged(),
        switchMap((keyword: string) => {
          if (!keyword || keyword.length < 3) {
            return of(null);
          }
          // Mismo endpoint que usa hotelsName. Filtramos en el front.
          const safe = encodeURIComponent(keyword);
          const req$ = this.restService.doGet('app', `search-locations/${safe}?category=HOTELS`);
          return req$.pipe(
            tap({
              error: (err: any) => {
                console.error('[destination] searchLocations failed', {
                  keyword,
                  status: err?.status,
                  url: err?.url,
                  body: err?.error
                });
              }
            })
          );
        }),
        takeUntil(this.destroy$)
      )
      .subscribe({
        next: (res: any) => {
          if (!res) {
            this.destinationOptions = [];
            return;
          }
          // Solo ciudades/ubicaciones en el dropdown.
          this.destinationOptions = [
            {
              cities: res?.cities || [],
              type: 'city',
            },
          ];
        },
        error: () => {
          this.destinationOptions = [];
        },
      });

this.formHotel.get('destination')?.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe((value: any) => {
        // Si el usuario borró el input manualmente (queda vacío o string que
        // no matchea con un objeto ciudad), limpiamos el IATA cacheado para
        // que el selector de hoteles vuelva al fallback /searchlocations.
        if (!value || typeof value === 'string') {
          if (this.selectedDestinationIata !== null) {
            this.selectedDestinationIata = null;
            this.hotelsNameOptions = [];
            this.hotelsByCityCache = [];
            this.loadingHotelsByCity = false;
          }
        }
        if (value && typeof value === 'object') {
          return;
        }
        this.destinationSearch$.next(value || '');
      });
  }

  /**
   * displayWith para el mat-autocomplete de destination.
   * Devuelve `city_name` (con provincia/país si están) o el string crudo.
   */
  displayDestinationFn = (value: any): string => {
    if (!value) {
      return '';
    }
    if (typeof value === 'string') {
      return value;
    }
    return value.city_name || value.name || '';
  };

/**
   * Maneja la selección de una ciudad del autocomplete de destination.
   * Guarda el objeto completo en el FormControl, marca formHotelEdited, y
   * extrae el IATA (`city_iata` / `city_iata_code`) para que el selector
   * de hoteles pueda usar el endpoint /hotels-by-city-iata/{iata}.
   * Si la ciudad no trae IATA, queda en fallback /searchlocations.
   *
   * Apenas se conoce el IATA, hace el fetch de TODOS los hoteles de esa
   * ciudad y los guarda en `hotelsByCityCache` para que el autocomplete
   * de "Nombre del hotel" filtre localmente sin volver a pegarle al backend.
   */
  onDestinationSelected(selected: any): void {
    if (!selected) {
      return;
    }
    this.formHotel.get('destination')?.setValue(selected);
    const iata = selected.city_iata || selected.city_iata_code || null;
    this.selectedDestinationIata = iata || null;
    this.formHotelEdited = true;
    // Limpiamos las opciones del selector de hoteles para forzar un refetch
    // cuando el usuario empiece a tipear en el input de "Nombre del hotel".
    this.hotelsNameOptions = [];
    // Si la ciudad trae IATA, precargamos todos los hoteles ahora para que
    // el usuario pueda filtrar localmente apenas tipee.
    if (iata) {
      this.fetchHotelsByCity(iata);
    } else {
      // Sin IATA: no hay endpoint de ciudad, caemos al searchlocations genérico.
      this.hotelsByCityCache = [];
      this.loadingHotelsByCity = false;
    }
  }

  /**
   * Trae todos los hoteles de una ciudad por su IATA y los guarda en
   * `hotelsByCityCache`. Maneja `loadingHotelsByCity` para el indicador
   * visual en el input de hotel. Se llama desde `onDestinationSelected`.
   */
  private fetchHotelsByCity(iata: string): void {
    this.loadingHotelsByCity = true;
    this.hotelsByCityCache = [];
    this.setHotelNamesDisabled(true);
    this.restService
      .doPost('app', 'utilities/hotels-by-city-iata', {
        iata,
      })
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: any) => {
          this.hotelsByCityCache = this.mapHotelsByCityResults(res);
          this.loadingHotelsByCity = false;
          this.setHotelNamesDisabled(false);
        },
        error: (err: any) => {
          this.loadingHotelsByCity = false;
          this.setHotelNamesDisabled(false);
          console.error('[form-offline] hotels-by-city-iata failed', {
            iata,
            status: err?.status,
            url: err?.url,
            body: err?.error,
          });
        },
      });
  }

  /**
   * Habilita / deshabilita los FormControl `name` de cada fila del
   * FormArray `hotelNames`. Usado mientras se cargan los hoteles por
   * ciudad para que el usuario no pueda tipear antes de que termine.
   */
  private setHotelNamesDisabled(disabled: boolean): void {
    if (!this.hotelNamesArray) return;
    this.hotelNamesArray.controls.forEach((row) => {
      const ctrl = row.get('name');
      if (!ctrl) return;
      if (disabled && ctrl.enabled) ctrl.disable();
      if (!disabled && ctrl.disabled) ctrl.enable();
    });
  }

  /**
   * displayWith para el mat-autocomplete de hotelsName.
   * Devuelve `name` si es hotel, `city_name` si es ciudad, o el string crudo si
   * el usuario está tipeando texto libre.
   */
  displayHotelsNameFn = (value: any): string => {
    if (!value) {
      return '';
    }
    if (typeof value === 'string') {
      return value;
    }
    // Hotel: tiene `name` y `city_name`. Ciudad: tiene `city_name` y `country_name`.
    return value.name || value.city_name || '';
  };

  /**
   * displayWith para el mat-autocomplete de files.
   * Devuelve el label legible cuando se selecciona un file, o vacío si se borra.
   */
  displayFileFn = (value: any): string => {
    if (!value) {
      return '';
    }
    if (typeof value === 'string') {
      return value;
    }
    if (value.__noResults) {
      return '';
    }
    return this.getFileLabel(value);
  };

  /**
   * Maneja la selección de un item del autocomplete. Guarda el objeto completo
   * en el FormControl para no perder info (tipo, id, iata) y marca formHotelEdited.
   */
  onHotelsNameSelected(selected: any): void {
    if (!selected) {
      return;
    }
    // eslint-disable-next-line no-console
    console.log('[form-offline] hotel seleccionado:', selected);
    this.hotelNamesArray.at(0).get('name')?.setValue(selected);
    this.formHotelEdited = true;

    // Apenas seleccionamos un hotel, pedimos los referential-costs al endpoint
    // /api/v1/zoco/hotels/{id}/referential-costs?market=1 para ver qué devuelve
    // el backend (exploratorio: solo logueamos por ahora).
    if (selected?.id != null) {
      this.fetchHotelReferentialCost(selected.id);
    }
  }

/**
   * Trae los costos referenciales de un hotel desde
   * /api/v1/zoco/hotels/{id}/referential-costs?market=1 y pinta el primero en
   * el FormControl `estimatedRate` (el input readonly "Valor estimado para el
   * hotel", bloque 2 derecha del formHotel).
   *
   * La respuesta esperada es:
   *   { data: [{ id, hotel_id, referential_cost: "12.00", ... }] }
   *
   * Comportamiento:
   *  - Si hay data y `referential_cost` parsea como número > 0, lo setea.
   *  - Si no, limpia el campo (evita arrastrar un valor viejo cuando el
   *    usuario cambia de hotel).
   *  - En edit mode (no reopen) el control está disabled: lo habilitamos
   *    momentáneamente para patchear, igual que hace `loadCountries` cuando
   *    necesita popular un control disabled.
   */
  private fetchHotelReferentialCost(hotelId: number | string): void {
    // Marcamos el id del pedido actual y levantamos el flag de loading.
    // Si el usuario cambia de hotel antes de que vuelva la respuesta, los
    // callbacks descartarán el resultado viejo comparando contra `latestReferentialHotelId`.
    this.latestReferentialHotelId = hotelId;
    this.loadingReferentialCost = true;

    this.restService
      .doGet('app', `zoco/hotels/${encodeURIComponent(String(hotelId))}/referential-costs`, { params: { market: 1 } })
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: any) => {
          // eslint-disable-next-line no-console
          console.log('[form-offline] referential-costs hotel', hotelId, ':', res);

          // Anti-race: si el usuario ya eligió otro hotel, descartamos esta respuesta.
          if (this.latestReferentialHotelId !== hotelId) {
            return;
          }
          this.loadingReferentialCost = false;

          const row = Array.isArray(res?.data) ? res.data[0] : null;
          const raw = row?.referential_cost;
          const parsed = raw != null ? parseFloat(String(raw)) : NaN;
          const value = Number.isFinite(parsed) && parsed > 0 ? parsed : null;

          this.setEstimatedRateValue(value);

          // Flag UI: el HTML muestra placeholder + icono "sin dato" cuando no
          // hay un referential_cost parseable > 0.
          this.hasReferentialCost = value !== null;
        },
        error: (err: any) => {
          // eslint-disable-next-line no-console
          console.error('[form-offline] referential-costs failed', {
            hotelId,
            status: err?.status,
            url: err?.url,
            body: err?.error,
          });
          // Si la respuesta fallida es del último hotel pedido, apagamos el loader.
          // Mantenemos `hasReferentialCost` en su valor previo (mismo criterio que
          // cuando el endpoint devuelve data vacía: no inventamos estado).
          if (this.latestReferentialHotelId === hotelId) {
            this.loadingReferentialCost = false;
          }
        },
      });
  }

  /**
   * Capitaliza un string tipo titulo (primera letra de cada palabra en mayuscula).
   * Replica lo que hace el search-box de hoteles para mantener consistencia visual.
   */
  capitalize(val: any): string {
    if (val === undefined || val === null) {
      return '';
    }
    return String(val)
      .toLowerCase()
      .trim()
      .split(' ')
      .map((v) => v.charAt(0).toUpperCase() + v.substring(1))
      .join(' ');
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
